import { Component } from 'react';
import { TweenMax, Back, Bounce, SteppedEase, Linear, Power1 } from 'gsap';
import SplitText from "gsap/SplitText";
import config from '../config/app.json';
import axios from 'axios';
import Hls from 'hls.js'
import { errorlog } from '../helpers/ErrorLogService';
import { OrderedMap, fromJS } from 'immutable';

export default class Player extends Component
{
  constructor(props)
  {
    super(props);
    this.addImagePlayerItems = this.addImagePlayerItems.bind(this);
    this.addTextOverlayItems = this.addTextOverlayItems.bind(this);
    this.addEffectsToItem = this.addEffectsToItem.bind(this);
    this.addSceneTransition = this.addSceneTransition.bind(this);
    this.addMask = this.addMask.bind(this);
    this.addMaskDOM = this.addMaskDOM.bind(this);
    this.textWriteEnterHandler = this.textWriteEnterHandler.bind(this);
    this.isPlaying = false;
    this.CancelToken = axios.CancelToken;
    this.source = this.CancelToken.source();
    this.playPromise = undefined;

    this.tweenToHandler = this.tweenToHandler.bind(this);
    this.tweenfromHandler = this.tweenfromHandler.bind(this);
    this.tweenFromToHandler = this.tweenFromToHandler.bind(this);
    this.tweenStaggerHandler = this.tweenFromToHandler.bind(this);
    this.tweenAddCallbackHandler = this.tweenAddCallbackHandler.bind(this);
    this.changeVideo = this.changeVideo.bind(this);
    this.pauseVideo = this.pauseVideo.bind(this);
    this.assetUrl = config["ASSETS"][config["ASSETS"]["current"]];
    this.appUrl = config['APPICONS'][config['APPICONS']['current']];
  }

  tweenToHandler(playerDOM, startTime, toVal, time)
  {
    this.props.addTween({ playerDOM: playerDOM, startTime: startTime, toVal: toVal, time: time }, "to");
  }

  tweenfromHandler(playerDOM, startTime, fromVal, time)
  {

    this.props.addTween({ playerDOM: playerDOM, startTime: startTime, fromVal: fromVal, time: time }, "from");

  }

  tweenFromToHandler(playerDOM, startTime, fromVal, toVal, time)
  {

    this.props.addTween({ playerDOM: playerDOM, startTime: startTime, fromVal: fromVal, toVal: toVal, time: time }, "fromTo");

  }

  tweenStaggerFromToHandler(playerDOM, startTime, fromVal, toVal, staggerTime, time)
  {
    this.props.addTween({ playerDOM: playerDOM, startTime: startTime, fromVal: fromVal, toVal: toVal, staggerTime: staggerTime, time: time }, "staggerFromTo");
  }

  tweenStaggerToHandler(playerDOM, startTime, toVal, staggerTime, time)
  {
    this.props.addTween({ playerDOM: playerDOM, startTime: startTime, toVal: toVal, staggerTime: staggerTime, time: time }, "staggerTo");
  }

  tweenStaggerFromHandler(playerDOM, startTime, fromVal, staggerTime, time, onComplete)
  {
    this.props.addTween({ playerDOM: playerDOM, startTime: startTime, fromVal: fromVal, staggerTime: staggerTime, time: time, onComplete: onComplete }, "staggerFrom");
  }

  tweenSetHandler(duration)
  {
    this.props.addTween({ time: duration }, "set");
  }

  tweenSetPropHandler(elem, vals) {
    this.props.addTween({ playerDOM: elem, setType: "styles", setVal: vals}, "set")
  }

  tweenAddCallbackHandler(valArr)
  {
    this.props.addTween(valArr, "addCallback");

  }



  addFilter(elementId, type)
  {
    var val = document.getElementById(elementId);
    if (val !== null)
    {
      var filter_tag = document.createElementNS('http://www.w3.org/2000/svg', "filter");
      var myfilter = "myfilter_" + elementId;
      var filter_name = "Blurfilter_" + elementId;
      var blurValue = 10;

      if (type === "remove")
        blurValue = 0;

      val.setAttributeNS(null, "filter", "url(#" + filter_name + ")");
      filter_tag.setAttributeNS(null, "id", filter_name);
      document.getElementById(elementId).parentElement.appendChild(filter_tag);

      var Blur = document.createElementNS('http://www.w3.org/2000/svg', "feGaussianBlur");
      Blur.setAttributeNS(null, "id", myfilter);
      Blur.setAttributeNS(null, "stdDeviation", blurValue);
      document.getElementById(filter_name).appendChild(Blur);
    }
  }

  removeMask(elementId)
  {
    var mask_name = "mymask_" + elementId;
    var elements = [];
    var tmpsvg, par;
    elements = document.querySelectorAll('*[id^="' + mask_name + '"]');

    for (var cnt = 0; cnt < elements.length; cnt++)
    {
      tmpsvg = document.getElementById(elements[cnt].id);
      if (tmpsvg !== null)
      {
        par = tmpsvg.parentNode;
        par.removeChild(tmpsvg);
        document.getElementById(elementId).removeAttribute("mask");
      }
    }

  }

  maskExist(elementId, type)
  {
    if (!type)
      type = "";

    if (document.getElementById("mymask_" + elementId + type))
      return true;
    else
      return false;
  }

  addMaskDOM(domName, idVal, xVal, yVal, widthVal, heightVal, strokeWidthVal)
  {
    var newDOM = document.createElementNS('http://www.w3.org/2000/svg', domName);
    newDOM.setAttributeNS(null, "id", idVal);
    newDOM.setAttributeNS(null, "x", xVal);
    newDOM.setAttributeNS(null, "y", yVal);
    newDOM.setAttributeNS(null, "width", widthVal);
    newDOM.setAttributeNS(null, "height", heightVal);
    newDOM.setAttributeNS(null, "stroke-width", strokeWidthVal);
    newDOM.setAttributeNS(null, "fill", "beige");
    newDOM.setAttributeNS(null, "stroke", "beige");
    return newDOM;
  }

  addSceneTransition(slides)
  {
    for (var j = 0; j < slides.size; j++)
    {

      if (j !== (slides.size - 1))
      {
        var thisSlide = document.getElementById("scene" + j);
        var nextSlide = document.getElementById("scene" + (j + 1));
        // scene Transitions  not playing issue fix
        if (j == 0) {
          thisSlide.style.opacity = 0;
          this.tweenToHandler(thisSlide, 0.01, { opacity: 1 }, 0-0.01)
        }

        var transitionTime = slides.getIn([j, "startTime"]) + slides.getIn([j, "duration"]);
        var transEffect = slides.getIn([j, "transEffect"]);

        if (transEffect === "NoTransition")
        {
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0  }, transitionTime)

          this.tweenFromToHandler(nextSlide, 0.000001, { autoAlpha: 0 }, { autoAlpha: 1   }, transitionTime)
        }
        else if (transEffect === "SlideFade")
        {
          this.tweenFromToHandler(thisSlide, 1, { autoAlpha: 1 }, { autoAlpha: 0 }, transitionTime)

          this.tweenFromToHandler(nextSlide, 1, { autoAlpha: 0 }, { autoAlpha: 1 }, transitionTime)
        }
        else if (transEffect === "SlideLeft")
        {
          this.tweenToHandler(thisSlide, 0.3, { x: this.projectWidth * this.props.zoomFactor * (-1) }, transitionTime)

          this.tweenFromToHandler(nextSlide, 0.3, { x: this.projectWidth * this.props.zoomFactor  }, { x: 0 }, transitionTime)
        }
        else if (transEffect === "SlideRight")
        {
          this.tweenToHandler(thisSlide, 0.3, { x: this.projectWidth * this.props.zoomFactor }, transitionTime)

          this.tweenFromToHandler(nextSlide, 0.3, { x: this.projectWidth * this.props.zoomFactor * (-1) }, { x: 0 }, transitionTime)
        }
        else if (transEffect === "SlideBottom")
        {
          this.tweenToHandler(thisSlide, 0.3, { y: this.projectHeight * this.props.zoomFactor }, transitionTime)

          this.tweenFromToHandler(nextSlide, 0.3, { y: this.projectHeight * this.props.zoomFactor * (-1) }, { y: 0 }, transitionTime)
        }
        else if (transEffect === "SlideTop")
        {
          this.tweenToHandler(thisSlide, 0.3, { y: this.projectHeight * this.props.zoomFactor * (-1) }, transitionTime)

          this.tweenFromToHandler(nextSlide, 0.3, { y: this.projectHeight * this.props.zoomFactor }, { y: 0 }, transitionTime)
        }
        else if (transEffect === "SlideBrightSquare")
        {
          this.brightSquareSlideEnterHandler(thisSlide, 0.8, transitionTime);
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+0.8)

        }
        else if (transEffect === "WipeLeft" || transEffect === "WipeTop" || transEffect === "WipeRight" || transEffect === "WipeBottom")
        {
          this.wipeExitHandler(thisSlide, 0.8, transitionTime, transEffect, 0, 1, 1)
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+0.8)
        }

        else if (transEffect === "SlideStripeLeft" || transEffect === "SlideStripeRight" || transEffect === "SlideStripeBottom" || transEffect === "SlideStripeTop")
        {
          this.stripeExitHandler(thisSlide, 0, 0, 0.8, transitionTime, transEffect, 1, 1)
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+0.8)
        }
        else if (transEffect === "SlideCircularReveal")
        {
          this.circularRevealExitHandler(thisSlide, 0.8, transEffect, transitionTime, 1, 1);
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+0.8)
        }
        else if (transEffect === "SlideIrisCircle")
        {
          this.irishExitHandler(thisSlide, 1, transitionTime, transEffect);
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+1)
        }
        else if (transEffect === "SlideIrisSquare")
        {
          this.irishExitHandler(thisSlide, 1, transitionTime, transEffect);
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+1)
        }
        else if (transEffect === "SlideBlindsVerLeft" || transEffect === "SlideBlindsVerRight" || transEffect === "SlideBlindsHorDown" || transEffect === "SlideBlindsHorUp")
        {
          this.blindsExitHandler(thisSlide, 0, 0, 0.8, transitionTime, transEffect, 1, 1)
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+0.8)
        }
        else if (transEffect === "SlideSplitVerticalOut" || transEffect === "SlideSplitHorizontalOut" || transEffect === "SlideSplitVerticalIn" || transEffect === "SlideSplitHorizontalIn" || transEffect === "SlideSplitMoveVer" || transEffect === "SlideSplitMoveHor")
        {
          this.SceneSplitHandler(thisSlide, 0.8, transitionTime, transEffect)
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+0.8)
        }
        else
        {
          this.tweenToHandler(thisSlide, 0.000001, { autoAlpha: 0 }, transitionTime+0.5)

          this.tweenFromToHandler(nextSlide, 0.000001, { autoAlpha: 0 }, { autoAlpha: 1 }, transitionTime+0.5)
        }
        
      }
    }
  }


  brightSquareSlideEnterHandler(innerblock, startTime, enterstart)
  {
    function onStartTween(blockId)
    {
      var maskFound = this.maskExist(blockId, "slidesquare");
      if (!maskFound) 
      {
        this.removeMask(blockId);
        this.addMask(blockId, "slidesquare");
      }

      var mask_rect = "#mask_" + innerblock.id + "_rect";
  
      TweenMax.set(mask_rect, { scale: 1, transformOrigin: "50% 50%" });
      TweenMax.set(innerblock, { scale: 1, transformOrigin: "50% 50%" });

      var totalCount = 6;
      for (var count = 0; count < totalCount; count++)
      {
        for (var cnt = 0; cnt < totalCount; cnt++)
        {
          if (this.props.browserName !== "Apple Safari")
            this.tweenToHandler(mask_rect + count + cnt, startTime, { transformOrigin: "50% 50%", scale: 0 }, enterstart)
          else
            this.tweenToHandler(mask_rect + count + cnt, startTime, { transformOrigin: "50% 50%", scale: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + innerblock.id + "square"] }, enterstart)

        }
      }

    }
    this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id], opacity: 1 }, enterstart);
  }

  SceneSplitHandler(innerblock, startTime, enterstart, transEffect)
  {
    function onStartTween(blockId)
    {
      var maskFound = this.maskExist(blockId, "split"), type = "split";
      if (!maskFound)
      {
        this.removeMask(blockId);
        if (transEffect === "SlideSplitHorizontalOut" || transEffect === "SlideSplitHorizontalIn" || transEffect === "SlideSplitMoveHor")
          this.addMask(blockId, "splitHor");
        else if (transEffect === "SlideSplitVerticalOut" || transEffect === "SlideSplitVerticalIn" || transEffect === "SlideSplitMoveVer")
          this.addMask(blockId, "splitVer");
      }

      var mask_rect = "#mask_" + blockId + "_rect";
      var totalCount = 2;
      var firstSplit, SecondSplit;

      TweenMax.set(mask_rect, { scale: 1, transformOrigin: "50% 50%" });
      TweenMax.set(innerblock, { scale: 1, transformOrigin: "50% 50%" });

      if (this.props.browserName !== "Apple Safari")
      {
        if (transEffect === "SlideSplitVerticalOut" || transEffect === "SlideSplitMoveHor")
        {
          firstSplit = { x: this.projectWidth * this.props.zoomFactor * (-1) };
          SecondSplit = { x: this.projectWidth * this.props.zoomFactor };
        }
        else if (transEffect === "SlideSplitMoveVer" || transEffect === "SlideSplitHorizontalOut")
        {
          firstSplit = { y: this.projectHeight * this.props.zoomFactor * (-1) };
          SecondSplit = { y: this.projectHeight * this.props.zoomFactor };
        }
        else if (transEffect === "SlideSplitHorizontalIn")
        {
          firstSplit = { transformOrigin: "50% 100%", scaleY: 0 };
          SecondSplit = { transformOrigin: "50% 0%", scaleY: 0 }
        }

        else if (transEffect === "SlideSplitVerticalIn")
        {
          firstSplit = { transformOrigin: "100% 50%", scaleX: 0 };
          SecondSplit = { transformOrigin: "0% 50%", scaleX: 0 }
        }
      }
      else
      {
        if (transEffect === "SlideSplitVerticalOut" || transEffect === "SlideSplitMoveHor")
        {
          firstSplit = { x: this.projectWidth * this.props.zoomFactor* (-1), onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
          SecondSplit = { x: this.projectWidth * this.props.zoomFactor, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
        }
        else if (transEffect === "SlideSplitMoveVer" || transEffect === "SlideSplitHorizontalOut")
        {
          firstSplit = { y: this.projectHeight * this.props.zoomFactor *  (-1), onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
          SecondSplit = { y: this.projectHeight * this.props.zoomFactor , onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
        }
        else if (transEffect === "SlideSplitHorizontalIn")
        {
          firstSplit = { transformOrigin: "50% 100%", scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
          SecondSplit = { transformOrigin: "50% 0%", scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }
        }

        else if (transEffect === "SlideSplitVerticalIn")
        {
          firstSplit = { transformOrigin: "100% 50%", scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] };
          SecondSplit = { transformOrigin: "0% 50%", scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }
        }
      }

      for (var count = 0; count < totalCount; count++)
      {
        if (count === 0)
          this.tweenToHandler(mask_rect + count, startTime, firstSplit, enterstart)
        else
          this.tweenToHandler(mask_rect + count, startTime, SecondSplit, enterstart)
      }
    }
    this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id], opacity: 1 }, enterstart);
  }

  addImagePlayerItems(nextProps, id, globalStart, enterEffectEnd, exitEfftectStart, isChild, sceneDuration)
  {
    var svg = document.getElementById(id);
    var scaleXVal = 1, scaleYVal = 1;

    if (nextProps.get("flipPosition") === 1)
      scaleXVal = -1;
    else if (nextProps.get("flipPosition") === 2)
      scaleYVal = -1;
    else if (nextProps.get("flipPosition") === 3)
    {
      scaleXVal = -1;
      scaleYVal = -1;
    }

    var correctedWidth = ((this.projectWidth * this.props.zoomFactor) / this.projectWidth) * nextProps.get("width");
    var correctedHeight = ((this.projectHeight * this.props.zoomFactor) / this.projectHeight) * nextProps.get("height");
    var originalPositionX = (nextProps.get("x") * ((this.projectWidth * this.props.zoomFactor) / this.projectWidth));
    var originalPositionY = (nextProps.get("y") * ((this.projectHeight * this.props.zoomFactor) / this.projectHeight));
    var opacityVal = (nextProps.get("opacity"))?nextProps.get("opacity"):1;

    var currentObj = fromJS({
      enter: nextProps.get("enterEffectName"),
      enterduration:enterEffectEnd - nextProps.get("enterStart") - 0.01,
      xval: originalPositionX,
      yval: originalPositionY,
      width: correctedWidth,
      height: correctedHeight,
      rotation: nextProps.get("angle"),
      scaleX: scaleXVal,
      scaleY: scaleYVal,
      opacity:opacityVal
    });

    var enterTime = parseFloat(nextProps.get("enterStart")+ globalStart);
    var exitTime = parseFloat(exitEfftectStart + globalStart);
    var objectEnd = parseFloat(nextProps.get("exitEnd") + globalStart);
    var innerblock = svg;
    this.addEffectsToItem(innerblock, currentObj, enterTime, exitTime, objectEnd, isChild)
  }

  addTextOverlayItems(nextProps, id, globalStart)
  {
    var svg = document.getElementById(id);
    var currentObj = fromJS({
      enter: nextProps.get("enterEffectName"),
      enterduration: nextProps.get("enterEnd") - nextProps.get("enterStart"),
      xval: nextProps.get("x"),
      yval: nextProps.get("y"),
      width: nextProps.get("width"),
      height: nextProps.get("height"),
      rotation: nextProps.get("angle")
    });
    var enterTime = parseFloat(nextProps.get("enterStart") + globalStart);
    var exitTime = parseFloat(nextProps.get("exitStart") + globalStart);
    var objectEnd = parseFloat(nextProps.get("exitEnd") + globalStart);
    var innerblock = svg;

    this.addEffectsToItem(innerblock, currentObj, enterTime, exitTime, objectEnd)
  }
  
  addEffectsToItem(playerElement, currentObj, enterTime, exitTime, objectEnd, isChild)
  {
    if (currentObj.get("enter") === "pixel"||currentObj.get("enter") === "photo"||currentObj.get("enter") === "stripeTopLeft" || currentObj.get("enter") === "stripe_Topright" || currentObj.get("enter") === "stripe_Bottomleft" || currentObj.get("enter") === "stripe_Bottomright"
    || currentObj.get("enter") === "stripeLeftTop" || currentObj.get("enter") === "stripeRightTop" || currentObj.get("enter") === "stripeLeftBottom" || currentObj.get("enter") === "stripeRightBottom"
    ||currentObj.get("enter") === "verticalSplit" || currentObj.get("enter") === "horizontalSplit"||currentObj.get("enter") === "irishSquare" || currentObj.get("enter") === "irishCircle"||currentObj.get("enter") === "brightSquare"||
    currentObj.get("enter") === "circularRevealClockwise" || currentObj.get("enter") === "circularRevealAntiClockwise" || currentObj.get("enter") === "circularRevealClockwiseRight" || currentObj.get("enter") === "circularRevealAntiClockwiseRight" || currentObj.get("enter") === "circularRevealClockwiseLeft" || currentObj.get("enter") === "circularRevealAntiClockwiseLeft" || currentObj.get("enter") === "circularRevealClockwiseBottom" || currentObj.get("enter") === "circularRevealAntiClockwiseBottom"||
    currentObj.get("enter") === "splitRevealFromTopCenter" || currentObj.get("enter") === "splitRevealFromBottomCenter" || currentObj.get("enter") === "splitRevealFromLeftCenter" || currentObj.get("enter") === "splitRevealFromRightCenter"||
    currentObj.get("enter") === "revealFromLeftBottom" || currentObj.get("enter") === "revealFromLeftTop" || currentObj.get("enter") === "revealFromRightBottom" || currentObj.get("enter") === "revealFromRightTop"||currentObj.get("enter") === "wipeTop" || currentObj.get("enter") === "wipeDown" || currentObj.get("enter") === "wipeRight" || currentObj.get("enter") === "wipeLeft")
    {
      TweenMax.set(playerElement, { opacity:parseFloat(currentObj.get("opacity")) });
      this.tweenToHandler(playerElement, currentObj.get("enterduration"), { opacity: currentObj.get("opacity")-0.01 }, enterTime - 0.01)
    }
    else 
    {
      TweenMax.set(playerElement, { opacity: 0 });
      if (currentObj.get("enter") !== "fadeIn")
        this.tweenToHandler(playerElement, 0.01, { opacity: currentObj.get("opacity") }, enterTime - 0.01)
    }
    // if (currentObj.get("enter") === "no_Effect")
    // {
    //   this.tweenToHandler(playerElement, 0.1, { opacity: currentObj.get("opacity")}, enterTime) 
    // } else
     if (currentObj.get("enter") === "drawSvg")
      this.t1.add(this.drawSVGHandler(playerElement, currentObj.get("enterduration")), enterTime);
    else if (currentObj.get("enter") === "fadeIn")
      this.fadeinHandler(playerElement, currentObj.get("enterduration"), enterTime, currentObj.get("opacity"), isChild);
    else if (currentObj.get("enter") === "fadeInZoomIn")
    this.fadeinWithZoom(playerElement, currentObj.get("enterduration"), currentObj.get("scaleX"), currentObj.get("scaleY"), currentObj.get("opacity"), currentObj.get("rotation"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
    else if (currentObj.get("enter") === "bigToNormal")
      this.bigToNormal(playerElement, currentObj.get("enterduration"), enterTime, currentObj.get("scaleX"), currentObj.get("scaleY"),currentObj.get("opacity"), currentObj.get("width"), currentObj.get("height"), currentObj.get("rotation"), isChild);
      else if (currentObj.get("enter") === "wipeTop" || currentObj.get("enter") === "wipeDown" || currentObj.get("enter") === "wipeRight" || currentObj.get("enter") === "wipeLeft")
      this.wipeEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("enter"), currentObj.get("rotation"), currentObj.get("scaleX"), currentObj.get("scaleY"), enterTime, isChild);
    else if (currentObj.get("enter") === "rotateZoomInPopupCw" || currentObj.get("enter") === "rotateZoomInPopupCcw")
      this.rotateZoominPopup(playerElement, currentObj.get("enterduration"), enterTime, currentObj.get("enter"), currentObj.get("rotation"), currentObj.get("scaleX"), currentObj.get("scaleY"), isChild);
    else if (currentObj.get("enter") === "rotateZoomInCw" || currentObj.get("enter") === "rotateZoomInCcw")
      this.rotateZoomin(playerElement, currentObj.get("enterduration"), enterTime, currentObj.get("enter"), currentObj.get("rotation"), currentObj.get("scaleX"), currentObj.get("scaleY"), isChild);
    else if (currentObj.get("enter") === "popup")
      this.popupHandler(playerElement, currentObj.get("enterduration"), currentObj.get("scaleX"), currentObj.get("scaleY"), enterTime,isChild);
    else if (currentObj.get("enter") === "popupFromLeft" || currentObj.get("enter") === "popupFromRight" || currentObj.get("enter") === "popupFromTop" || currentObj.get("enter") === "popupFromBottom" || currentObj.get("enter") === "popupFromBottomRight" || currentObj.get("enter") === "popupFromCenter" || currentObj.get("enter") === "popupFromBottomLeft" || currentObj.get("enter") === "popupFromTopLeft" || currentObj.get("enter") === "popupFromTopRight")
      this.popupTransformHandler(playerElement, currentObj.get("enterduration"), currentObj.get("scaleX"), currentObj.get("scaleY"), enterTime, currentObj.get("enter"), currentObj.get("rotation"), currentObj.get("xval"), currentObj.get("yval"), isChild);

    else if (currentObj.get("enter") === "pixel")
      this.pixelEnterHandler(playerElement, currentObj.get("xval"), currentObj.get("yval"), currentObj.get("enterduration"), enterTime, isChild);
    else if (currentObj.get("enter") === "photo")
      this.photoEnterHandler(playerElement, currentObj.get("xval"), currentObj.get("yval"), currentObj.get("enterduration"), enterTime, isChild);
    else if (currentObj.get("enter") === "blindsLeft" || currentObj.get("enter") === "blindsRight" || currentObj.get("enter") === "blindsTop" || currentObj.get("enter") === "blindsBottom")
      this.blindsEnterHandler(playerElement, currentObj.get("xval"), currentObj.get("yval"), currentObj.get("enterduration"), enterTime, currentObj.get("enter"), currentObj.get("scaleX"), currentObj.get("scaleY"), isChild);
    else if (currentObj.get("enter") === "scaleTop" || currentObj.get("enter") === "scaleDown" || currentObj.get("enter") === "scaleRight" || currentObj.get("enter") === "scaleLeft")
      this.scaleEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("enter"), currentObj.get("scaleX"), currentObj.get("scaleY"), enterTime, currentObj.get("rotation"), isChild);
    else if (currentObj.get("enter") === "rotation")
      this.rotationEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("rotation"), currentObj.get("scaleX"), currentObj.get("scaleY"), enterTime, isChild);
    else if (currentObj.get("enter") === "stripeTopLeft" || currentObj.get("enter") === "stripe_Topright" || currentObj.get("enter") === "stripe_Bottomleft" || currentObj.get("enter") === "stripe_Bottomright"
      || currentObj.get("enter") === "stripeLeftTop" || currentObj.get("enter") === "stripeRightTop" || currentObj.get("enter") === "stripeLeftBottom" || currentObj.get("enter") === "stripeRightBottom")
      this.stripeEnterHandler(playerElement, currentObj.get("xval"), currentObj.get("yval"), currentObj.get("enterduration"), enterTime, currentObj.get("enter"), currentObj.get("scaleX"), currentObj.get("scaleY"), isChild);
    else if (currentObj.get("enter") === "moveFromTop" || currentObj.get("enter") === "moveFromDown" || currentObj.get("enter") === "moveFromRight" || currentObj.get("enter") === "moveFromLeft")
      this.moveEnterHandler(playerElement, currentObj.get("xval"), currentObj.get("yval"), currentObj.get("rotation"), currentObj.get("enterduration"), enterTime, currentObj.get("enter"), currentObj.get("scaleX"), currentObj.get("scaleY"), isChild);
    else if (currentObj.get("enter") === "verticalSplit" || currentObj.get("enter") === "horizontalSplit")
      this.splitFromCenterEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("enter"), enterTime, isChild);
    else if (currentObj.get("enter") === "irishSquare" || currentObj.get("enter") === "irishCircle")
      this.irishEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("enter"), enterTime, isChild);
    else if (currentObj.get("enter") === "brightSquare")
      this.brightSquareEnterHandler(playerElement, currentObj.get("xval"), currentObj.get("yval"), currentObj.get("enterduration"), enterTime, isChild);
    else if (currentObj.get("enter") === "bounce")
      this.bounceEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("yval"), enterTime, currentObj.get("opacity"), isChild)
    else if (currentObj.get("enter") === "circularRevealClockwise" || currentObj.get("enter") === "circularRevealAntiClockwise" || currentObj.get("enter") === "circularRevealClockwiseRight" || currentObj.get("enter") === "circularRevealAntiClockwiseRight" || currentObj.get("enter") === "circularRevealClockwiseLeft" || currentObj.get("enter") === "circularRevealAntiClockwiseLeft" || currentObj.get("enter") === "circularRevealClockwiseBottom" || currentObj.get("enter") === "circularRevealAntiClockwiseBottom")
      this.circularRevealEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("enter"), enterTime, currentObj.get("scaleX"), currentObj.get("scaleY"), isChild);
    else if (currentObj.get("enter") === "splitRevealFromTopCenter" || currentObj.get("enter") === "splitRevealFromBottomCenter" || currentObj.get("enter") === "splitRevealFromLeftCenter" || currentObj.get("enter") === "splitRevealFromRightCenter")
      this.splitRevealEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("enter"), enterTime, currentObj.get("scaleX"), currentObj.get("scaleY"), isChild);
    else if (currentObj.get("enter") === "revealFromLeftBottom" || currentObj.get("enter") === "revealFromLeftTop" || currentObj.get("enter") === "revealFromRightBottom" || currentObj.get("enter") === "revealFromRightTop")
      this.revealFromEnterHandler(playerElement, currentObj.get("enterduration"), currentObj.get("enter"), enterTime, currentObj.get("scaleX"), currentObj.get("scaleY"), isChild);
    else if (currentObj.get("enter") === "textWrite")
      this.textWriteEnterHandler(playerElement, currentObj.get("enterduration"), this.t1, enterTime, isChild);
    else if (currentObj.get("enter") === "splitText")
      this.splitTextEnterHandler(playerElement, currentObj.get("enterduration"), this.t1, enterTime, isChild);
    else if (currentObj.get("enter") === "handWrite")
      this.handWriteEnterHandler(playerElement, currentObj.get("enterduration"), enterTime, isChild);
    else if (currentObj.get("enter") === "enterFromLeftBottom")
      this.EnterFromLeftBottom(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("width"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
    else if (currentObj.get("enter") === "enterFromLeftTop")
      this.EnterFromLeftTop(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("width"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
    else if (currentObj.get("enter") === "enterFromRightBottom")
      this.EnterFromRightBottom(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("width"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
    else if (currentObj.get("enter") === "enterFromRightTop")
      this.EnterFromRightTop(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("width"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
    else if (currentObj.get("enter") === "enterFromTop")
      this.EnterFromTop(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("width"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
    else if (currentObj.get("enter") === "enterFromLeft")
      this.EnterFromLeft(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("width"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
    else if (currentObj.get("enter") === "enterFromBottom")
      this.EnterFromBottom(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("width"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
    else if (currentObj.get("enter") === "enterFromRight")
      this.EnterFromRight(playerElement, currentObj.get("enterduration"), currentObj.get("height"), currentObj.get("width"), currentObj.get("xval"), currentObj.get("yval"), enterTime, isChild);
      
  }

  videoOnTimeUpdate = (videoElement, videoDOM, currentSceneStart, volume, list, globalThumb, currentScene) => {
    if(videoDOM.play && videoElement.get("videoEnd") < videoDOM.currentTime) {
      videoDOM.pause();
      videoDOM.currentTime = 0;
    }
  }

  changeVideo(videoDOM, index)
  {
    this.props.changeVideoIndex(index);
    videoDOM.currentTime = 0 ;
    document.querySelectorAll('video').forEach(vid => vid.pause());
    // document.getElementById("video-controls-" + index).style.opacity = 0

    // videoDOM.ontimeupdate = () => this.videoOnTimeUpdate(videoElement, videoDOM, currentSceneStart, volume, list, globalThumb, currentScene);

    // var playStart = videoElement.get('enterStart');
    // var musicStart = videoElement.get('videoStart');

    // if (playStart < 0)
    // {
    //   musicStart = musicStart + (this.props.playStart);
    //   playStart = 0;
    // }
    // videoDOM.volume = videoElement.get("volume")/100;
    // videoDOM.currentTime = musicStart + globalThumb;
    // videoDOM.muted = videoElement.get('videoMute');

    // if((this.props.projectData.getIn(["scenes", currentScene, "startTime"]) + this.props.projectData.getIn(["scenes", currentScene, "duration"])) > currentSceneStart && this.props.localStore.get("isPlayAll"))
    //   this.playPromise = videoDOM.play();
  }

  pauseVideo(sceneIndex,isEnd=false){
    if(!isEnd)
    document.querySelectorAll('video').forEach(vid => vid.pause());
  }

  componentDidMount()
  {
    this.t1 = this.props.t1
    this.isPlaying = true;
    this.projectWidth = this.props.projectData.get("width");
    this.projectHeight = this.props.projectData.get("height");
    document.getElementsByClassName("scenes")[0].style.width = "100%";//this.projectWidth + "px"
    document.getElementsByClassName("scenes")[0].style.height = "100%";//this.projectHeight + "px"
    document.getElementsByClassName("scenes")[0].style.overflow = "hidden"

    this.addPlayerEssentials(this.props)
  }

  componentWillUnmount()
  {
    this.source.cancel('Operation canceled by the user.');
    this.props.changePlayTime(0)

    this.addImagePlayerItems = null;
    this.addTextOverlayItems = null;
    this.addEffectsToItem = null;
    this.addSceneTransition = null;
    this.addMaskDOM = null;
    this.textWriteEnterHandler = null;
    this.CancelToken = null;
    this.source = null;
    this.tweenToHandler = null;
    this.tweenfromHandler = null;
    this.tweenFromToHandler = null;
    this.tweenStaggerHandler = null;
    this.tweenAddCallbackHandler = null;
    this.playPromise = undefined;
  }

  
  // filterWorkspaceItems = (workspaceItems, workspaceChildren) => {
  //   var itemsToLoad = OrderedMap();
  //   workspaceItems.entrySeq().forEach(([item, workspaceItem]) => {
  //     if(workspaceItem.get("type") === "GROUP") {
  //       if(workspaceItem.get("enterEffectName") !== "no_Effect" && (workspaceItem.get("groupChildren").size !== 0)) {
  //         itemsToLoad = itemsToLoad.setIn([item], workspaceItem);
  //         itemsToLoad = itemsToLoad.setIn([item, "isChild"], false);
  //       }
  //       else {
  //         workspaceChildren.entrySeq().forEach(([item, child]) => {
  //           if(workspaceItem.getIn(["groupChildren"]).includes(item)) {
  //             itemsToLoad = itemsToLoad.setIn([item], child);
  //             itemsToLoad = itemsToLoad.setIn([item, "isChild"], true);
  //           }
  //         })
  //       }
  //     } else {
  //       itemsToLoad = itemsToLoad.setIn([item], workspaceItem);
  //       itemsToLoad = itemsToLoad.setIn([item, "isChild"], false);
  //     }
  //   })
  //   return itemsToLoad;
  // }

  filterWorkspaceItemsAnimate =(clonedProjectData)=>{
    for (let m = 0; m < clonedProjectData.getIn(['scenes']).size; m++)
    {
      let itemsToLoad = OrderedMap();
      const workspaceItems = clonedProjectData.getIn(['scenes', m, 'workspaceItems']).sortBy(item => item.get('animIndex'));
      const workspaceChildren = clonedProjectData.getIn(['scenes', m, 'workspaceChildren']).sortBy(item => item.get('animIndex'));
      workspaceItems.entrySeq().forEach(([item, workspaceItem]) => {
        if(workspaceItem.get("type") === "GROUP") {
          if(!(workspaceItem.get("enterEffectName") === "no_Effect" && workspaceItem.get('animType') === 'On Load')) {
            itemsToLoad = itemsToLoad.setIn([item], workspaceItem);
            itemsToLoad = itemsToLoad.setIn([item, "isChild"], false);
          }
          else {
            workspaceChildren.entrySeq().forEach(([item, child]) => {
              if(workspaceItem.getIn(["groupChildren"]).includes(item)) {
                itemsToLoad = itemsToLoad.setIn([item], child);
                itemsToLoad = itemsToLoad.setIn([item, "isChild"], true);
              }
            })
          }
        } else {
          itemsToLoad = itemsToLoad.setIn([item], workspaceItem);
          itemsToLoad = itemsToLoad.setIn([item, "isChild"], false);  
        }
      })
      let animIndex = 0 ;
      itemsToLoad.entrySeq().forEach(([item, workspaceItem]) => {
        itemsToLoad = itemsToLoad.setIn([item , 'animIndex'],animIndex)
        animIndex = animIndex+1 ;
      })
      clonedProjectData = clonedProjectData.setIn(['scenes',m,'workspaceItems'],itemsToLoad);
    }
    return clonedProjectData;
  }
  fetchTransitionTime=(transEffect)=>
  {
        if (transEffect === "NoTransition") return 0;
        else if (transEffect === "SlideFade" || transEffect === "SlideIrisCircle" ||
        transEffect === "SlideIrisSquare") return 1.1;
        else if (transEffect === "SlideLeft" || transEffect === "SlideRight" || transEffect === "SlideBottom"
        || transEffect === "SlideTop") return 0.4;
        else if (transEffect === "SlideBrightSquare" || transEffect === "WipeLeft" || transEffect === "WipeTop" || transEffect === "WipeRight" || transEffect === "WipeBottom"
        || transEffect === "SlideStripeLeft" || transEffect === "SlideStripeRight" || transEffect === "SlideStripeBottom" || transEffect === "SlideStripeTop"
        || transEffect === "SlideCircularReveal" || transEffect === "SlideBlindsVerLeft" || transEffect === "SlideBlindsVerRight" || transEffect === "SlideBlindsHorDown" || transEffect === "SlideBlindsHorUp"
        || transEffect === "SlideSplitVerticalOut" || transEffect === "SlideSplitHorizontalOut" 
        || transEffect === "SlideSplitVerticalIn" || transEffect === "SlideSplitHorizontalIn" || 
        transEffect === "SlideSplitMoveVer" || transEffect === "SlideSplitMoveHor" ) return 0.9; 
        else return 1;
  }

  processProjectData(projectData)
  {
    var projectDataCopy = new OrderedMap(projectData);
    var clonedProjectData = this.filterWorkspaceItemsAnimate(projectDataCopy);
    var labelName = 0
    let slideLabelData= {};
    for (var m = 0; m < clonedProjectData.getIn(['scenes']).size; m++)
    {
      //to sort the items using key animIndex
      const sortedItems = clonedProjectData.getIn(['scenes', m, 'workspaceItems']).sortBy(item => item.get('animType') != "On Load");
      var currentTime = 0;
      let startTimeDelay = 0;
      let delayed = false;
      let isClick = false;
      sortedItems.entrySeq().forEach(([key, value]) =>{
        let transition = clonedProjectData.getIn(['scenes',m-1,'transEffect']);
        let isDelayReq = (value.get('enterEffectName') === 'no_Effect' || m === 0 || transition === 'NoTransition')? false:true;
        if(value.get("animType") == "On Load")
        {
         if(!isDelayReq){
          clonedProjectData = clonedProjectData.setIn(['scenes', m, 'workspaceItems', key, 'enterStart'], 0)
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterEnd"],  0.5)
          }
          else{
          let timeDelay = this.fetchTransitionTime(transition);
          startTimeDelay = Math.max(timeDelay,startTimeDelay);
          delayed = true;
          clonedProjectData = clonedProjectData.setIn(['scenes', m, 'workspaceItems', key, 'enterStart'], timeDelay)
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterEnd"],  0.5+timeDelay)
          }
        }
        else if(value.get("animType") == "On Click"){
          isClick = true;
          if(!delayed){
            currentTime += 1
            this.props.t1.addPause(clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime-0.01);
            labelName +=1
            this.props.t1.addLabel(labelName, clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime+0.01);
            clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterStart"],  currentTime)
            clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterEnd"],  currentTime+0.5)
          }
          else{
          let timeDelay = this.fetchTransitionTime(transition);
          startTimeDelay = startTimeDelay + timeDelay;
          currentTime += 1
          this.props.t1.addPause(clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime-0.01+0.5+timeDelay);
          labelName +=1
          this.props.t1.addLabel(labelName, clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime+0.01+0.5+timeDelay);
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterStart"],  currentTime+0.5+timeDelay)
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterEnd"],  currentTime+0.5+0.5+timeDelay)
          }
        }
        else if(value.get("animType") == "With Previous"){
         if(!isDelayReq){
            clonedProjectData= clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterStart"], currentTime)
            clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterEnd"],  currentTime+0.5)
          }
          else{
            let timeDelay = this.fetchTransitionTime(transition);
            startTimeDelay = Math.max(timeDelay,startTimeDelay);
            delayed = true;
            let timer = 0;
            if(isClick){
              timer = 0.5;
            }
          clonedProjectData= clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterStart"], currentTime+timer+timeDelay)
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterEnd"],  currentTime+0.5+timer+timeDelay)
          }
        }
        else if(value.get("animType") == "After Previous"){
          isClick = true;
          if(!delayed){
          currentTime += 1
          labelName +=1
          this.props.t1.addLabel(labelName, clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime+0.01);
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterStart"], currentTime+0.01)
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterEnd"],  currentTime+0.5)
          }
          else{
          let timeDelay = this.fetchTransitionTime(transition);
          startTimeDelay = startTimeDelay + timeDelay;
          currentTime += 1
          labelName +=1
          this.props.t1.addLabel(labelName, clonedProjectData.getIn(['scenes', m, "startTime"]) + currentTime+0.01+0.5+timeDelay);
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterStart"], currentTime+0.01+0.5+timeDelay)
          clonedProjectData=clonedProjectData.setIn(['scenes', m, "workspaceItems", key, "enterEnd"],  currentTime+0.5+0.5+timeDelay)
          }
          
        }
      })
      clonedProjectData = clonedProjectData.setIn(['scenes', m, "duration"], currentTime + 1 + startTimeDelay)

      if(m < clonedProjectData.getIn(['scenes']).size -1)
    {
      clonedProjectData=clonedProjectData.setIn(['scenes', m+1, "startTime"], clonedProjectData.getIn(['scenes', m, "duration"]) + clonedProjectData.getIn(['scenes', m, "startTime"]))
    }
    if(!this.props.autoPlay)
    {
        this.props.t1.addPause(clonedProjectData.getIn(['scenes', m, "startTime"]) + clonedProjectData.getIn(['scenes', m, "duration"])-0.01);
        labelName +=1
        this.props.t1.addLabel(labelName, clonedProjectData.getIn(['scenes', m, "startTime"]) + clonedProjectData.getIn(['scenes', m, "duration"])+0.01);
        slideLabelData[m+1]={
          'slide':m+1,
          'label':labelName
        }  
    }
    }
    this.props.addSlideLabelData(slideLabelData);
    return clonedProjectData;

  }

  addPlayerEssentials(nextProps)
  {
    var selectedScene = nextProps.localStore.get('selectedScene');
    var filteredItems, workspaceItems, workspaceChildren

    if (nextProps.projectData.getIn(['scenes']).size > 0) 
    {
      if (nextProps.localStore.get('isPlayAll'))
      {
        var projectData = this.processProjectData(nextProps.projectData)
        this.addSceneTransition(projectData.getIn(['scenes']))

        for (var m = 0; m < projectData.getIn(['scenes']).size; m++)
        {
          var slideStartTime = projectData.getIn(['scenes', m, "startTime"])
          workspaceItems = projectData.getIn(['scenes', m, 'workspaceItems']);
          workspaceChildren = projectData.getIn(['scenes', m, 'workspaceChildren']);
          //filteredItems = this.filterWorkspaceItems(workspaceItems, workspaceChildren);
          workspaceItems.entrySeq().forEach(([key, value]) =>
          {
            if (nextProps.localStore.get('isPlayAll'))
            {
              var enterEffectEnd = value.get("enterEnd");
              var exitEfftectStart = value.get("exitStart");

              if (value.getIn(['type']) === "TXTOVLY")
              {
                for (var mk = 0; mk < value.get('groupChildren').size; mk++)
                {
                  var textTmp = value.getIn(['groupChildren', mk])
                  var childVal = projectData.getIn(['scenes', m, 'workspaceChildren', textTmp])
                  this.addTextOverlayItems(childVal, textTmp, slideStartTime);
                }
              }
              else
              {
                this.addImagePlayerItems(value, key, slideStartTime, enterEffectEnd, exitEfftectStart, value.getIn(['isChild']), projectData.getIn(['scenes', selectedScene, 'duration']), projectData.getIn(['scenes', m, 'duration']));
              }
            }
          })

          if (projectData.getIn(['scenes', m, "workspaceBG", "src"]) !== "")
          {
            if (projectData.getIn(['scenes', m, "workspaceBG", "type"]) === "VIDEO" || projectData.getIn(['scenes', m, "workspaceBG", "type"]) === "STOCKVID"  || projectData.getIn(['scenes', m, "workspaceBG", "type"]) === "UPVIDEO" || projectData.getIn(['scenes', m, "workspaceBG", "type"]) === "ZOOM")
            {

              var imageDiv = document.getElementById("scene" + m).getElementsByClassName("scenes")[0].getElementsByClassName("bg-video")[0];
              this.tweenToHandler(imageDiv, 0.01, { opacity: 1 }, slideStartTime);


              var workspaceBg = projectData.getIn(['scenes', m, "workspaceBG"])
              var videoElement = workspaceBg;
              var videoDOM = document.getElementById("scene" + m).getElementsByClassName("scenes")[0].getElementsByClassName("bg-video")[0]


              var playStart = projectData.getIn(['scenes', m, "startTime"]); //slideStartTime + workspaceBg.get('enterStart');
              var valArr = {}

              var bgDOM = document.getElementById("scene" + m).getElementsByClassName("scenes")[0].getElementsByClassName("bg-container");

              var playEnd = projectData.getIn(['scenes', m, "startTime"])+projectData.getIn(['scenes', m, "duration"])
              var globalStart = 0
              if(this.props.selectedScene === m)
              {
                globalStart = this.props.playAllThumb - projectData.getIn(['scenes', m, "startTime"])
              }

              valArr.callBack = this.changeVideo
              valArr.startTime = playStart
              valArr.dataArr = [videoDOM, m];
              this.props.addTween(valArr, "addCallback");

              var changeArr = {};
              changeArr.callBack = this.pauseVideo 
              changeArr.startTime = playEnd;
              if(m === this.props.projectData.get('scenes').size-1)
              {
                changeArr.dataArr =[m,true]
              }
              else{
              changeArr.dataArr = [m];
              }
              this.props.addTween(changeArr,'addCallback');             

            }

          }

        }


        var currentSceneStart = projectData.getIn(['scenes', selectedScene, 'startTime'])




          this.tweenSetHandler(projectData.getIn(["duration"]))
          var valArr = {}
          valArr.callBack = this.PlayEnded.bind(this)
          valArr.startTime = projectData.getIn(["duration"])
          valArr.dataArr = []
          this.tweenAddCallbackHandler(valArr)

          if (window.totalArr.length === 0)
            this.props.startPlay("workspace")

          this.props.startPlay("player", "player",projectData.getIn(['scenes', selectedScene, "playHeadValue"]), projectData.getIn(['scenes', selectedScene, "startTime"]))


      }
    }
  }

  PlayEnded()
  {

    // if (this.props.localStore.get('isPlayAll'))
    //   this.props.setPlayAll(false)
  }

  render()
  {
    return null;
  }

  splitTextEnterHandler(innerblock, startTime, t1, exitstart, isChild)
  {
    function nestedLinesSplit(target, vars)
    {
      var split = new SplitText(target, vars),
        words = (vars.type.indexOf("words") !== -1),
        chars = (vars.type.indexOf("chars") !== -1),
        insertAt = function (a, b, i)
        {
          var l = b.length,
            j;
          for (j = 0; j < l; j++)
          {
            a.splice(i++, 0, b[j]);
          }
          return l;
        },
        children, child, i;

      if (typeof (target) === "string")
      {
        target = document.querySelectorAll(target);
      }
      if (target.length > 1)
      {
        for (i = 0; i < target.length; i++)
        {
          split.lines = split.lines.concat(nestedLinesSplit(target[i], vars).lines);
        }
        return split;
      }

      children = (words ? split.words : []).concat(chars ? split.chars : []);
      for (i = 0; i < children.length; i++)
      {
        children[i]._protect = true;
      }

      children = split.lines;
      for (i = 0; i < children.length; i++)
      {
        child = children[i].firstChild;
        if (!child._protect && child.nodeType !== 3)
        {
          children[i].parentNode.insertBefore(child, children[i]);
          children[i].parentNode.removeChild(children[i]);
          children.splice(i, 1);
          i += insertAt(children, nestedLinesSplit(child, vars).lines, i) - 1;
        }
      }
      return split;
    }
    var assetTexts = innerblock.getElementsByClassName("text-container")[0];
    if (assetTexts !== undefined && assetTexts !== null)
    {
      var mySplitText = nestedLinesSplit(assetTexts, { type: "lines" });
      for(let i = 0; i< mySplitText.lines.length; i++) {
        mySplitText.lines[i].style.visibility = "hidden";
      }

      this.tweenStaggerFromToHandler(
        mySplitText.lines,
        startTime / mySplitText.lines.length,
        {
          left: this.projectWidth * this.props.zoomFactor,
          visibility: "visible"
        },
        { left: 0, visibility: "visible", onComplete: setVisibility },
        startTime / mySplitText.lines.length,
        exitstart
      );

      function setVisibility() {
        for(let i = 0; i< mySplitText.lines.length; i++) {
          mySplitText.lines[i].style.visibility = "visible";
        }
      }
    }
  }

  textWriteEnterHandler(innerblock, duration, t1, enterstart, isChild)
  {
    var cursorSpan = document.createElement('span');
    cursorSpan.id =  "cursorCls" + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
    cursorSpan.className = 'cursorCls'

    if (!innerblock.contains(document.getElementById("cursorCls")))
      innerblock.appendChild(cursorSpan);

    var assetTexts = innerblock.getElementsByClassName("text-container")[0], isUnderline = false;
    if (assetTexts.style.textDecoration === "underline")
    {
      let textValue = assetTexts.innerHTML;
      textValue = textValue.split(' ').join('&nbsp;');
      assetTexts.innerHTML = textValue;
    }

    var cursor = document.getElementById(cursorSpan.id);
    cursor.style.left = "0px";
    cursor.style.height = "0px";
    cursor.style.opacity = "1";

    if (assetTexts !== undefined && assetTexts !== null)
    {
      var mySplitText = new SplitText(assetTexts, { type: "chars", reduceWhiteSpace: false }),
      chars = mySplitText.chars;
      let textDivs = innerblock.getElementsByClassName("text-container")[0].getElementsByTagName('div');
      if (assetTexts.style.textDecoration === "underline")
      {
        assetTexts.style.textDecoration = "unset";
        isUnderline = true;
        for (let t = 0; t < textDivs.length; t++)
        {
          textDivs[t].style.textDecoration = "underline";
        }
      }

      for(let txt = 0; txt<textDivs.length; txt++ ) {
        if(textDivs[txt].getElementsByTagName("div").length === 0) {
          textDivs[txt].style.display = "inline";
          textDivs[txt].style.opacity = "0";
        }
      }

      this.tweenStaggerToHandler(chars.slice(), 0.0001, { opacity: 1, ease: Power1.easeIn, onStart: placeCursor }, duration / chars.length, enterstart, allDone);
      this.t1.addCallback(hideCursor, enterstart + duration)
      function allDone()
      {
        mySplitText.revert();
        if (isUnderline)
          assetTexts.style.textDecoration = "underline";
      }
      function placeCursor()
      {
        cursor.style.height = this.target.offsetHeight + "px";
        cursor.style.left = this.target.offsetWidth + "px";
        this.target.appendChild(cursorSpan);
        blink();
      }
      function blink()
      {
        TweenMax.fromTo(cursor, 0.3, { opacity: 1 }, { opacity: 0, repeat: -1, ease: Linear.easeNone });
      }
      function hideCursor()
      {
        cursor.outerHTML = "";
      }
    }
  }

  handWriteEnterHandler(innerblock, duration, enterstart, isChild)
  {
    var handSpan = document.createElement('span'), handOffset = 10;
    handSpan.id = "hand" + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
    handSpan.className = 'handPenCls'

    if (!innerblock.contains(document.getElementById("hand")))
      innerblock.appendChild(handSpan);

    var assetTexts = innerblock.getElementsByClassName("text-container")[0], isUnderline = false;
    if (assetTexts.style.textDecoration === "underline")
    {
      let textValue = assetTexts.innerHTML;
      textValue = textValue.split(' ').join('&nbsp;');
      assetTexts.innerHTML = textValue;
    }

    var hand = document.getElementById(handSpan.id);
    hand.style.left = "0px";

    if (assetTexts !== undefined && assetTexts !== null)
    {
      var mySplitText = new SplitText(assetTexts, { type: "chars", reduceWhiteSpace: false }),
      chars = mySplitText.chars;
      let textDivs = innerblock.getElementsByClassName("text-container")[0].getElementsByTagName('div');
      if (assetTexts.style.textDecoration === "underline")
      {
        assetTexts.style.textDecoration = "unset";
        isUnderline = true;
        for (let t = 0; t < textDivs.length; t++)
        {
          textDivs[t].style.textDecoration = "underline";
        }
      }
      for(let txt = 0; txt<textDivs.length; txt++ ) {
        if(textDivs[txt].getElementsByTagName("div").length === 0) {
          textDivs[txt].style.display = "inline";
          textDivs[txt].style.opacity = "0";
        }
      }

      this.tweenStaggerToHandler(chars.slice(), 0.0001, { opacity: 1, ease: Power1.easeIn, onStart: placeHand }, (duration - (duration * 0.2)) / chars.length, enterstart, allDone);
      this.tweenToHandler(hand, duration * 0.2, { y: this.projectHeight * this.props.zoomFactor }, (enterstart + duration - (duration * 0.2)));
      this.t1.addCallback(hideHand, enterstart + duration)
      function allDone()
      {
        mySplitText.revert();
        if (isUnderline)
          assetTexts.style.textDecoration = "underline";
      }
      function placeHand()
      {
        hand.style.left = (this.target.offsetWidth - handOffset) + "px";
        this.target.appendChild(handSpan);
        blink();
      }
      function blink()
      {
        TweenMax.fromTo(hand, 0.5, { opacity: 1 }, { repeat: -1, ease: Linear.easeNone });
      }
      function hideHand()
      {
        hand.outerHTML = "";
      }
    }
  }


  revealFromEnterHandler(innerblock, startTime, effectType, enterTime, scaleX, scaleY, isChild)
  {
    this.addMask(innerblock.id, "reveal", null, null, null, null, null, false);
    var mask_rect = "#mask_" + innerblock.id + "_rect";
    var idVal = document.getElementById(innerblock.id);
    if (scaleX === -1 || scaleY === -1)
    {
      if (effectType === "revealFromLeftBottom" && scaleX === -1 && scaleY === 1) effectType = "revealFromRightBottom";
      else if (effectType === "revealFromLeftBottom" && scaleY === -1 && scaleX === 1) effectType = "revealFromLeftTop";
      else if (effectType === "revealFromLeftBottom" && scaleY === -1 && scaleX === -1) effectType = "revealFromRightTop";
      else if (effectType === "revealFromLeftTop" && scaleX === -1 && scaleY === 1) effectType = "revealFromRightTop";
      else if (effectType === "revealFromLeftTop" && scaleY === -1 && scaleX === 1) effectType = "revealFromLeftBottom";
      else if (effectType === "revealFromLeftTop" && scaleY === -1 && scaleX === -1) effectType = "revealFromRightBottom";
      else if (effectType === "revealFromRightTop" && scaleX === -1 && scaleY === 1) effectType = "revealFromLeftTop";
      else if (effectType === "revealFromRightTop" && scaleY === -1 && scaleX === 1) effectType = "revealFromRightBottom";
      else if (effectType === "revealFromRightTop" && scaleY === -1 && scaleX === -1) effectType = "revealFromLeftBottom";
      else if (effectType === "revealFromRightBottom" && scaleX === -1 && scaleY === 1) effectType = "revealFromLeftBottom";
      else if (effectType === "revealFromRightBottom" && scaleY === -1 && scaleX === 1) effectType = "revealFromRightTop";
      else if (effectType === "revealFromRightBottom" && scaleY === -1 && scaleX === -1) effectType = "revealFromLeftTop";
    }
    if (effectType === "revealFromLeftBottom")
      this.tweenFromToHandler(mask_rect, startTime, { attr: { x: (idVal.offsetWidth) * -1, y: (idVal.offsetHeight) } }, { attr: { x: 0, y: 0 } }, enterTime);
    else if (effectType === "revealFromLeftTop")
      this.tweenFromToHandler(mask_rect, startTime, { attr: { x: (idVal.offsetWidth) * -1, y: (idVal.offsetHeight) * -1 } }, { attr: { x: 0, y: 0 } }, enterTime);
    else if (effectType === "revealFromRightBottom")
      this.tweenFromToHandler(mask_rect, startTime, { attr: { x: (idVal.offsetWidth), y: (idVal.offsetHeight) } }, { attr: { x: 0, y: 0 } }, enterTime);
    else if (effectType === "revealFromRightTop")
      this.tweenFromToHandler(mask_rect, startTime, { attr: { x: (idVal.offsetWidth), y: (idVal.offsetHeight) * -1 } }, { attr: { x: 0, y: 0 } }, enterTime);
    this.tweenToHandler(innerblock, 0.01, {"clip-path": ""}, startTime+enterTime);
  }

  splitRevealEnterHandler(innerblock, startTime, effectType, enterTime, scaleX, scaleY, isChild)
  {
    this.removeMask(innerblock.id);
    this.addMask(innerblock.id, "circularReveal");

    if (scaleX === -1 || scaleY === -1)
    {
      if (effectType === "splitRevealFromTopCenter" && scaleY === -1) effectType = "splitRevealFromBottomCenter";
      else if (effectType === "splitRevealFromBottomCenter" && scaleY === -1) effectType = "splitRevealFromTopCenter";
      else if (effectType === "splitRevealFromRightCenter" && scaleX === -1) effectType = "splitRevealFromLeftCenter";
      else if (effectType === "splitRevealFromLeftCenter" && scaleX === -1) effectType = "splitRevealFromRightCenter";
    }

    var offsetWidthVal = document.getElementById(innerblock.id).offsetWidth;
    var offsetHeightVal = document.getElementById(innerblock.id).offsetHeight;

    var clipPath = document.querySelector("#arcPath" + innerblock.id);
    var radiusVal = Math.max(offsetWidthVal, offsetHeightVal)
    var effectVars = {}

    if (effectType === "splitRevealFromTopCenter")
      effectVars = { start: 360, mainStart: 540, mainEnd: 180 }
    else if (effectType === "splitRevealFromRightCenter")
      effectVars = { start: 90, mainStart: 270, mainEnd: -90 }
    else if (effectType === "splitRevealFromBottomCenter")
      effectVars = { start: 180, mainStart: 360, mainEnd: 0 }
    else if (effectType === "splitRevealFromLeftCenter")
      effectVars = { start: 270, mainStart: this.projectHeight, mainEnd: 90 }

    radiusVal = 0.5 * Math.sqrt((offsetWidthVal * offsetWidthVal) + (offsetHeightVal * offsetHeightVal));

    var arc = { start: effectVars.start, end: effectVars.start, cx: offsetWidthVal / 2, cy: offsetHeightVal / 2, r: radiusVal };

    this.tweenToHandler(arc, startTime, { start: effectVars.mainStart, end: effectVars.mainEnd, ease: Linear.easeNone, onUpdate: updatePath }, enterTime);
    this.tweenToHandler(innerblock, 0.01, {"clip-path": ""}, startTime + enterTime);

    function updatePath()
    {
      clipPath.setAttribute("d", getPath(arc.cx, arc.cy, arc.r, arc.end, arc.start));
    }

    function getPath(cx, cy, r, a1, a2)
    {
      var delta = a2 - a1;
      if (delta === 360)
      {
        return "M " + (cx - r) + " " + cy + " a " + r + " " + r + " 0 1 0 " + r * 2 + " 0 a " + r + " " + r + " 0 1 0 " + -r * 2 + " 0z";
      }
      var largeArc = delta > 180 ? 1 : 0;
      a1 = a1 * Math.PI / 180 - Math.PI / 2;
      a2 = a2 * Math.PI / 180 - Math.PI / 2;
      var x1 = cx + r * Math.cos(a2);
      var y1 = cy + r * Math.sin(a2);
      var x2 = cx + r * Math.cos(a1);
      var y2 = cy + r * Math.sin(a1);
      return "M " + x1 + " " + y1 + " A " + r + " " + r + " 0 " + largeArc + " 0 " + x2 + " " + y2 + " L " + cx + " " + cy + "z";
    }
  }

  circularRevealEnterHandler(innerblock, startTime, effectType, enterTime, scaleX, scaleY, isChild)
  {
    this.removeMask(innerblock.id);
    this.addMask(innerblock.id, "circularReveal");

    var offsetWidthVal = document.getElementById(innerblock.id).offsetWidth;
    var offsetHeightVal = document.getElementById(innerblock.id).offsetHeight;

    if (scaleX === -1 || scaleY === -1)
    {
      if (effectType === "circularRevealClockwise" && scaleX === -1 && scaleY === 1) effectType = "circularRevealAntiClockwise";
      else if (effectType === "circularRevealClockwise" && scaleX === 1 && scaleY === -1) effectType = "circularRevealAntiClockwiseBottom";
      else if (effectType === "circularRevealClockwise" && scaleX === -1 && scaleY === -1) effectType = "circularRevealClockwiseBottom";
      else if (effectType === "circularRevealAntiClockwise" && scaleX === -1 && scaleY === 1) effectType = "circularRevealClockwise";
      else if (effectType === "circularRevealAntiClockwise" && scaleX === 1 && scaleY === -1) effectType = "circularRevealClockwiseBottom";
      else if (effectType === "circularRevealAntiClockwise" && scaleX === -1 && scaleY === -1) effectType = "circularRevealAntiClockwiseBottom";
      else if (effectType === "circularRevealClockwiseRight" && scaleX === -1 && scaleY === 1) effectType = "circularRevealAntiClockwiseLeft";
      else if (effectType === "circularRevealClockwiseRight" && scaleX === 1 && scaleY === -1) effectType = "circularRevealAntiClockwiseRight";
      else if (effectType === "circularRevealClockwiseRight" && scaleX === -1 && scaleY === -1) effectType = "circularRevealClockwiseLeft";
      else if (effectType === "circularRevealAntiClockwiseRight" && scaleX === -1 && scaleY === 1) effectType = "circularRevealClockwiseLeft";
      else if (effectType === "circularRevealAntiClockwiseRight" && scaleX === 1 && scaleY === -1) effectType = "circularRevealClockwiseRight";
      else if (effectType === "circularRevealAntiClockwiseRight" && scaleX === -1 && scaleY === -1) effectType = "circularRevealAntiClockwiseLeft";
      else if (effectType === "circularRevealClockwiseLeft" && scaleX === -1 && scaleY === 1) effectType = "circularRevealAntiClockwiseRight";
      else if (effectType === "circularRevealClockwiseLeft" && scaleX === 1 && scaleY === -1) effectType = "circularRevealAntiClockwiseLeft";
      else if (effectType === "circularRevealClockwiseLeft" && scaleX === -1 && scaleY === -1) effectType = "circularRevealClockwiseRight";
      else if (effectType === "circularRevealAntiClockwiseLeft" && scaleX === -1 && scaleY === 1) effectType = "circularRevealClockwiseRight";
      else if (effectType === "circularRevealAntiClockwiseLeft" && scaleX === 1 && scaleY === -1) effectType = "circularRevealClockwiseLeft";
      else if (effectType === "circularRevealAntiClockwiseLeft" && scaleX === -1 && scaleY === -1) effectType = "circularRevealAntiClockwiseRight";
      else if (effectType === "circularRevealClockwiseBottom" && scaleX === -1 && scaleY === 1) effectType = "circularRevealAntiClockwiseBottom";
      else if (effectType === "circularRevealClockwiseBottom" && scaleX === 1 && scaleY === -1) effectType = "circularRevealAntiClockwise";
      else if (effectType === "circularRevealClockwiseBottom" && scaleX === -1 && scaleY === -1) effectType = "circularRevealClockwise";
      else if (effectType === "circularRevealAntiClockwiseBottom" && scaleX === -1 && scaleY === 1) effectType = "circularRevealClockwiseBottom";
      else if (effectType === "circularRevealAntiClockwiseBottom" && scaleX === 1 && scaleY === -1) effectType = "circularRevealClockwise";
      else if (effectType === "circularRevealAntiClockwiseBottom" && scaleX === -1 && scaleY === -1) effectType = "circularRevealAntiClockwise";
    }

    var clipPath = document.querySelector("#arcPath" + innerblock.id);
    var radiusVal = (offsetWidthVal > offsetHeightVal) ? offsetWidthVal : offsetHeightVal;
    var effectVars = {}

    if (effectType === "circularRevealClockwise")
      effectVars = { start: 0, end: 360 }
    else if (effectType === "circularRevealAntiClockwise")
      effectVars = { start: 360, end: 0 }
    else if (effectType === "circularRevealClockwiseRight")
      effectVars = { start: 90, end: this.projectHeight }
    else if (effectType === "circularRevealAntiClockwiseRight")
      effectVars = { start: 90, end: -270 }
    else if (effectType === "circularRevealClockwiseLeft")
      effectVars = { start: 270, end: 630 }
    else if (effectType === "circularRevealAntiClockwiseLeft")
      effectVars = { start: 270, end: -90 }
    else if (effectType === "circularRevealClockwiseBottom")
      effectVars = { start: 180, end: 540 }
    else if (effectType === "circularRevealAntiClockwiseBottom")
      effectVars = { start: 180, end: -180 }

    var arc = { start: effectVars.start, end: effectVars.start, cx: offsetWidthVal / 2, cy: offsetHeightVal / 2, r: radiusVal };

    if (effectType === "circularRevealClockwise" || effectType === "circularRevealClockwiseRight" || effectType === "circularRevealClockwiseLeft" ||
      effectType === "circularRevealClockwiseBottom")
    {
      this.tweenToHandler(arc, startTime, { end: effectVars.end, ease: Linear.easeNone, onUpdate: updatePath }, enterTime);
      function updatePath()
      {
        clipPath.setAttribute("d", getPath(arc.cx, arc.cy, arc.r, arc.start, arc.end));
      }
    }

    else if (effectType === "circularRevealAntiClockwise" || effectType === "circularRevealAntiClockwiseRight" || effectType === "circularRevealAntiClockwiseLeft" ||
      effectType === "circularRevealAntiClockwiseBottom")
    {
      this.tweenToHandler(arc, startTime, { end: effectVars.end, ease: Linear.easeNone, onUpdate: updatePath }, enterTime);
      function updatePath()
      {
        clipPath.setAttribute("d", getPath(arc.cx, arc.cy, arc.r, arc.end, arc.start));
      }
    }

    function getPath(cx, cy, r, a1, a2)
    {
      var delta = a2 - a1;
      if (delta === 360)
      {
        return "M " + (cx - r) + " " + cy + " a " + r + " " + r + " 0 1 0 " + r * 2 + " 0 a " + r + " " + r + " 0 1 0 " + -r * 2 + " 0z";
      }
      var largeArc = delta > 180 ? 1 : 0;
      a1 = a1 * Math.PI / 180 - Math.PI / 2;
      a2 = a2 * Math.PI / 180 - Math.PI / 2;
      var x1 = cx + r * Math.cos(a2);
      var y1 = cy + r * Math.sin(a2);
      var x2 = cx + r * Math.cos(a1);
      var y2 = cy + r * Math.sin(a1);
      return "M " + x1 + " " + y1 + " A " + r + " " + r + " 0 " + largeArc + " 0 " + x2 + " " + y2 + " L " + cx + " " + cy + "z";
    }
  }

  circularRevealExitHandler(innerblock, startTime, effectType, time, scaleX, scaleY, opacity, isChild)
  {
    var effectVars = {}
    var clipPath = document.querySelector("#arcPath" + innerblock.id);

    var offsetWidthVal = document.getElementById(innerblock.id).offsetWidth;
    var offsetHeightVal = document.getElementById(innerblock.id).offsetHeight;

    if (scaleX === -1 || scaleY === -1)
    {
      if (effectType === "circularHideClockwise" && scaleX === -1 && scaleY === 1) effectType = "circularHideAntiClockwise";
      else if (effectType === "circularHideClockwise" && scaleX === 1 && scaleY === -1) effectType = "circularHideAntiClockwiseBottom";
      else if (effectType === "circularHideClockwise" && scaleX === -1 && scaleY === -1) effectType = "circularHideClockwiseBottom";
      else if (effectType === "circularHideAntiClockwise" && scaleX === -1 && scaleY === 1) effectType = "circularHideClockwise";
      else if (effectType === "circularHideAntiClockwise" && scaleX === 1 && scaleY === -1) effectType = "circularHideClockwiseBottom";
      else if (effectType === "circularHideAntiClockwise" && scaleX === -1 && scaleY === -1) effectType = "circularHideAntiClockwiseBottom";
      else if (effectType === "circularHideClockwiseRight" && scaleX === -1 && scaleY === 1) effectType = "circularHideAntiClockwiseLeft";
      else if (effectType === "circularHideClockwiseRight" && scaleX === 1 && scaleY === -1) effectType = "circularHideAntiClockwiseRight";
      else if (effectType === "circularHideClockwiseRight" && scaleX === -1 && scaleY === -1) effectType = "circularHideClockwiseLeft";
      else if (effectType === "circularHideAntiClockwiseRight" && scaleX === -1 && scaleY === 1) effectType = "circularHideClockwiseLeft";
      else if (effectType === "circularHideAntiClockwiseRight" && scaleX === 1 && scaleY === -1) effectType = "circularHideClockwiseRight";
      else if (effectType === "circularHideAntiClockwiseRight" && scaleX === -1 && scaleY === -1) effectType = "circularHideAntiClockwiseLeft";
      else if (effectType === "circularHideClockwiseLeft" && scaleX === -1 && scaleY === 1) effectType = "circularHideAntiClockwiseRight";
      else if (effectType === "circularHideClockwiseLeft" && scaleX === 1 && scaleY === -1) effectType = "circularHideAntiClockwiseLeft";
      else if (effectType === "circularHideClockwiseLeft" && scaleX === -1 && scaleY === -1) effectType = "circularHideClockwiseRight";
      else if (effectType === "circularHideAntiClockwiseLeft" && scaleX === -1 && scaleY === 1) effectType = "circularHideClockwiseRight";
      else if (effectType === "circularHideAntiClockwiseLeft" && scaleX === 1 && scaleY === -1) effectType = "circularHideClockwiseLeft";
      else if (effectType === "circularHideAntiClockwiseLeft" && scaleX === -1 && scaleY === -1) effectType = "circularHideAntiClockwiseRight";
      else if (effectType === "circularHideClockwiseBottom" && scaleX === -1 && scaleY === 1) effectType = "circularHideAntiClockwiseBottom";
      else if (effectType === "circularHideClockwiseBottom" && scaleX === 1 && scaleY === -1) effectType = "circularHideAntiClockwise";
      else if (effectType === "circularHideClockwiseBottom" && scaleX === -1 && scaleY === -1) effectType = "circularHideClockwise";
      else if (effectType === "circularHideAntiClockwiseBottom" && scaleX === -1 && scaleY === 1) effectType = "circularHideClockwiseBottom";
      else if (effectType === "circularHideAntiClockwiseBottom" && scaleX === 1 && scaleY === -1) effectType = "circularHideClockwise";
      else if (effectType === "circularHideAntiClockwiseBottom" && scaleX === -1 && scaleY === -1) effectType = "circularHideAntiClockwise";
    }

    var radiusVal = (offsetWidthVal > offsetHeightVal) ? offsetWidthVal : offsetHeightVal;
    if (effectType === "circularHideAntiClockwise")
      effectVars = { start: 0, endEnter: 360, endExit: 0 }
    else if (effectType === "circularHideClockwise" || effectType === "SlideCircularReveal")
      effectVars = { start: 360, endEnter: 0, endExit: 360 }
    else if (effectType === "circularHideAntiClockwiseRight")
      effectVars = { start: 90, endEnter: this.projectHeight, endExit: 90 }
    else if (effectType === "circularHideClockwiseRight")
      effectVars = { start: 90, endEnter: -270, endExit: 90 }
    else if (effectType === "circularHideAntiClockwiseLeft")
      effectVars = { start: 270, endEnter: 630, endExit: 270 }
    else if (effectType === "circularHideClockwiseLeft")
      effectVars = { start: 270, endEnter: -90, endExit: 270 }
    else if (effectType === "circularHideAntiClockwiseBottom")
      effectVars = { start: 180, endEnter: 540, endExit: 180 }
    else if (effectType === "circularHideClockwiseBottom")
      effectVars = { start: 180, endEnter: -180, endExit: 180 }

    var arc = { start: effectVars.start, end: effectVars.endEnter, cx: offsetWidthVal / 2, cy: offsetHeightVal / 2, r: radiusVal };
    function onStartTween(blockId, type)
    {
      this.removeMask(innerblock.id);
      this.addMask(innerblock.id, "circularReveal");
      clipPath = document.querySelector("#arcPath" + innerblock.id);

      TweenMax.set("arcPath" + innerblock.id, { opacity: 1, transformOrigin: "50% 50%" });
      TweenMax.set(innerblock, { opacity: opacity, transformOrigin: "50% 50%" });
    }

    if (effectType === "circularHideAntiClockwise" || effectType === "circularHideAntiClockwiseRight" || effectType === "circularHideAntiClockwiseLeft" ||
      effectType === "circularHideAntiClockwiseBottom")
    {
      this.tweenToHandler(arc, startTime, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, ""], end: effectVars.endExit, ease: Linear.easeNone, onUpdate: updatePath }, time);
      function updatePath()
      {
        if (clipPath !== null)
          clipPath.setAttribute("d", getPath(arc.cx, arc.cy, arc.r, arc.start, arc.end));
      }
    }

    else if (effectType === "circularHideClockwise" || effectType === "SlideCircularReveal" || effectType === "circularHideClockwiseRight" || effectType === "circularHideClockwiseLeft" ||
      effectType === "circularHideClockwiseBottom")
    {
      this.tweenToHandler(arc, startTime, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, ""], end: effectVars.endExit, ease: Linear.easeNone, onUpdate: updatePath.bind(this) }, time);
      function updatePath()
      {
        if (effectType === "SlideCircularReveal" && this.props.browserName === "Apple Safari")
          this.redrawClipPath(innerblock, "#mymask_" + innerblock.id + "circularReveal");
        if (clipPath !== null)
          clipPath.setAttribute("d", getPath(arc.cx, arc.cy, arc.r, arc.end, arc.start));
      }
    }

    function getPath(cx, cy, r, a1, a2)
    {
      var delta = a2 - a1;
      if (delta === 360)
      {
        return "M " + (cx - r) + " " + cy + " a " + r + " " + r + " 0 1 0 " + r * 2 + " 0 a " + r + " " + r + " 0 1 0 " + -r * 2 + " 0z";
      }
      var largeArc = delta > 180 ? 1 : 0;
      a1 = a1 * Math.PI / 180 - Math.PI / 2;
      a2 = a2 * Math.PI / 180 - Math.PI / 2;
      var x1 = cx + r * Math.cos(a2);
      var y1 = cy + r * Math.sin(a2);
      var x2 = cx + r * Math.cos(a1);
      var y2 = cy + r * Math.sin(a1);
      return "M " + x1 + " " + y1 + " A " + r + " " + r + " 0 " + largeArc + " 0 " + x2 + " " + y2 + " L " + cx + " " + cy + "z";
    }
  }

  stripeEnterHandler(innerblock, xval, yval, startTime, enterstart, effectType, scaleX, scaleY, isChild)
  {
    this.removeMask(innerblock.id);
    var mask_rect = "#mask_" + innerblock.id + "_rect";

    if (scaleY === -1 || scaleX === -1)
    {
      if (effectType === "stripeTopLeft" && scaleY === -1 && scaleX === 1) effectType = "stripe_Bottomleft";
      else if (effectType === "stripeTopLeft" && scaleX === -1 && scaleY === 1) effectType = "stripe_Topright";
      else if (effectType === "stripeTopLeft" && scaleX === -1 && scaleY === -1) effectType = "stripe_Bottomright";
      else if (effectType === "stripe_Topright" && scaleY === -1 && scaleX === 1) effectType = "stripe_Bottomright";
      else if (effectType === "stripe_Topright" && scaleX === -1 && scaleY === 1) effectType = "stripeTopLeft";
      else if (effectType === "stripe_Topright" && scaleX === -1 && scaleY === -1) effectType = "stripe_Bottomleft";
      else if (effectType === "stripe_Bottomleft" && scaleY === -1 && scaleX === 1) effectType = "stripeTopLeft";
      else if (effectType === "stripe_Bottomleft" && scaleX === -1 && scaleY === 1) effectType = "stripe_Bottomright";
      else if (effectType === "stripe_Bottomleft" && scaleX === -1 && scaleY === -1) effectType = "stripe_Topright";
      else if (effectType === "stripe_Bottomright" && scaleY === -1 && scaleX === 1) effectType = "stripe_Topright";
      else if (effectType === "stripe_Bottomright" && scaleX === -1 && scaleY === 1) effectType = "stripe_Bottomleft";
      else if (effectType === "stripe_Bottomright" && scaleX === -1 && scaleY === -1) effectType = "stripeTopLeft";
      else if (effectType === "stripeLeftTop" && scaleY === -1 && scaleX === 1) effectType = "stripeLeftBottom";
      else if (effectType === "stripeLeftTop" && scaleX === -1 && scaleY === 1) effectType = "stripeRightTop";
      else if (effectType === "stripeLeftTop" && scaleX === -1 && scaleY === -1) effectType = "stripeRightBottom";
      else if (effectType === "stripeRightTop" && scaleY === -1 && scaleX === 1) effectType = "stripeRightBottom";
      else if (effectType === "stripeRightTop" && scaleX === -1 && scaleY === 1) effectType = "stripeLeftTop";
      else if (effectType === "stripeRightTop" && scaleX === -1 && scaleY === -1) effectType = "stripeLeftBottom";
      else if (effectType === "stripeLeftBottom" && scaleY === -1 && scaleX === 1) effectType = "stripeLeftTop";
      else if (effectType === "stripeLeftBottom" && scaleX === -1 && scaleY === 1) effectType = "stripeRightBottom";
      else if (effectType === "stripeLeftBottom" && scaleX === -1 && scaleY === -1) effectType = "stripeRightTop";
      else if (effectType === "stripeRightBottom" && scaleY === -1 && scaleX === 1) effectType = "stripeRightTop";
      else if (effectType === "stripeRightBottom" && scaleX === -1 && scaleY === 1) effectType = "stripeLeftBottom";
      else if (effectType === "stripeRightBottom" && scaleX === -1 && scaleY === -1) effectType = "stripeLeftTop";
    }

    if (effectType === "stripeLeftBottom" || effectType === "stripeRightBottom" || effectType === "stripeLeftTop" || effectType === "stripeRightTop")
      this.addMask(innerblock.id, "multiWidth");

    else if (effectType === "stripe_Topright" || effectType === "stripe_Bottomleft" || effectType === "stripeTopLeft" || effectType === "stripe_Bottomright")
      this.addMask(innerblock.id, "multiHeight");

    var totalCount = 10;
    var num = 0;
    for (var count = totalCount; count >= 0; count--)
    {
      if (effectType === "stripeLeftBottom")
        this.tweenFromToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "bottom", scaleY: 0 }, { transformOrigin: "bottom", scaleY: 1 }, enterstart + ((count * startTime) / totalCount));
      else if (effectType === "stripeRightBottom")
        this.tweenFromToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "bottom", scaleY: 0 }, { transformOrigin: "bottom", scaleY: 1 }, enterstart + ((num * startTime) / totalCount));
      else if (effectType === "stripe_Bottomright")
        this.tweenFromToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "100%", scaleX: 0 }, { transformOrigin: "100%", scaleX: 1 }, enterstart + ((num * startTime) / totalCount));
      else if (effectType === "stripeLeftTop")
        this.tweenFromToHandler(mask_rect + count, startTime / totalCount, { scaleY: 0 }, { scaleY: 1 }, enterstart + ((count * startTime) / totalCount));
      else if (effectType === "stripeRightTop")
        this.tweenFromToHandler(mask_rect + count, startTime / totalCount, { scaleY: 0 }, { scaleY: 1 }, enterstart + ((num * startTime) / totalCount));
      else if (effectType === "stripe_Topright")
        this.tweenFromToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "100%", scaleX: 0 }, { transformOrigin: "100%", scaleX: 1 }, enterstart + ((count * startTime) / totalCount));
      else if (effectType === "stripe_Bottomleft")
        this.tweenFromToHandler(mask_rect + count, startTime / totalCount, { scaleX: 0 }, { scaleX: 1 }, enterstart + ((num * startTime) / totalCount));
      else if (effectType === "stripeTopLeft")
        this.tweenFromToHandler(mask_rect + count, startTime / totalCount, { scaleX: 0 }, { scaleX: 1 }, enterstart + ((count * startTime) / totalCount));
      num++;
    }
  }


  fadeinHandler(innerblock, startTime, enterstart, opacity, isChild)
  {
    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { opacity: 0 });
    this.tweenToHandler(innerblock, startTime, { opacity: opacity, immediateRender: false, ease: Back.easeNone }, enterstart);
  }

  scaleEnterHandler(innerblock, startTime, effectType, scaleX, scaleY, enterTime, rotation, isChild)
  {
    this.removeMask(innerblock.id);
    var onStartTween = () => {
      if (effectType === "scaleTop")
        this.tweenFromToHandler(innerblock.children[0], startTime, { scaleY: 0 }, { opacity: 1, scaleY: scaleY, transformOrigin: "0% 0%" }, enterTime)
      else if (effectType === "scaleDown")
        this.tweenFromToHandler(innerblock.children[0], startTime, { scaleY: 0, transformOrigin: "0% 100%" }, { scaleY: scaleY, transformOrigin: "0% bottom" }, enterTime)
      else if (effectType === "scaleRight")
        this.tweenFromToHandler(innerblock.children[0], startTime, { scaleX: 0, transformOrigin: "100% 0%" }, { opacity: 1, scaleX: scaleX, transformOrigin: "right 0%" }, enterTime)
      else if (effectType === "scaleLeft")
        this.tweenFromToHandler(innerblock.children[0], startTime, { scaleX: 0 }, { opacity: 1, scaleX: scaleX, transformOrigin: "0% 0%" }, enterTime)
    }
    this.tweenAddCallbackHandler({callBack: onStartTween, startTime: 0.1, dataArr: []});
  }

  bounceEnterHandler(innerblock, startTime, heightVal, yVal, enterTime, opacity, isChild)
  {
    var groupYoffset = 0;
    if(isChild)
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    this.removeMask(innerblock.id);
    this.tweenFromToHandler(innerblock, startTime, { y: (heightVal + groupYoffset) * -1 }, { opacity: opacity, y: (yVal - groupYoffset), ease: Bounce.easeOut, immediateRender: false }, enterTime)
  }

  redrawClipPath(innerblock, mask_rect)
  {
    innerblock.style.clipPath = "none";
    innerblock.style.clipPath = "url(" + mask_rect + ")";
    innerblock.style.webkitClipPath = "url(" + mask_rect + ")"; innerblock.style.mozClipPath = "url(" + mask_rect + ")"; innerblock.style.msClipPath = "url(" + mask_rect + ")"; innerblock.style.oClipPath = "url(" + mask_rect + ")";
  }

  addMask(elementId, type, direction, rotation, scaleX, scaleY, effectType, isScene) 
  {
    var val = document.getElementById(elementId);
    var bounds = val.getBoundingClientRect();
    if (!scaleX) scaleX = 1; if (!scaleY) scaleY = 1;
    if (!direction)
      direction = "";
    if (!type)
      type = "";
    if (val !== null) {
      var mask_rect = "mask_" + elementId + "_rect";
      var mask_tag = document.createElementNS('http://www.w3.org/2000/svg', "clipPath");
      var mask_name, myRect;
      var mySVG = document.createElementNS('http://www.w3.org/2000/svg', "svg");
      var totalCount = 10, count;

      if (type === "multiWidth" || type === "multiHeight") {
        mask_name = "mymask_" + elementId + type;
        let h = val.offsetHeight;
        let w = val.offsetWidth;
        val.style.clipPath = "url(#" + mask_name + ")";
        val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";
        mask_tag.setAttributeNS(null, "id", mask_name);
        for (count = 0; count < totalCount; count++) {
          if (type === "multiWidth")
          myRect = this.addMaskDOM("rect", (mask_rect + count), ((count * (w / totalCount))), 0, ((w / totalCount) + 1), h, val.getAttribute("stroke-width"))
        else if (type === "multiHeight")
            myRect = this.addMaskDOM("rect", (mask_rect + count), 0, ((count * h / totalCount)), w, ((h / totalCount) + 1), val.getAttribute("stroke-width"))
          mask_tag.appendChild(myRect);
        }

        mySVG.setAttributeNS(null, "width", 0);
        mySVG.setAttributeNS(null, "height", 0);

        mySVG.appendChild(mask_tag);
        document.getElementById(elementId).appendChild(mySVG);
      }
      else if (type === "square" || type === "slidesquare" || type === "pixelsquare") {

        if (effectType !== "exit") {
          mask_name = "mymask_" + elementId + type;
        }
        else {
          mask_name = "mymask_" + elementId + "exitsquare";
          mask_rect += "exit"
        }

        val.style.clipPath = "url(#" + mask_name + ")";
        val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";
        mask_tag.setAttributeNS(null, "id", mask_name);
        let h = document.getElementById(elementId).offsetHeight;
        let w = document.getElementById(elementId).offsetWidth;
        var totalSquare = 6;
        if (type === "square") totalSquare = 6;
        for (count = 0; count < totalSquare; count++) {
          for (var cnt = 0; cnt < totalSquare; cnt++) {

            var changeValY = cnt * h / totalSquare;
            var changeValX = count * w / totalSquare;
            myRect = this.addMaskDOM("rect", (mask_rect + count + cnt), changeValX, changeValY, ((w / totalSquare) + 1), ((h / totalSquare) + 1), val.getAttribute("stroke-width"));
            mask_tag.appendChild(myRect);
          }
        }

        mySVG.setAttributeNS(null, "width", 0);
        mySVG.setAttributeNS(null, "height", 0);

        mySVG.appendChild(mask_tag);
        document.getElementById(elementId).appendChild(mySVG);
      }
      else if (type === "splitVer" || type === "splitHor") {
        totalCount = 2;

        mask_name = "mymask_" + elementId + "split";
        val.style.clipPath = "url(#" + mask_name + ")";
        val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";
        mask_tag.setAttributeNS(null, "id", mask_name);
        let h = bounds.height;
        let w = bounds.width;
        for (count = 0; count < totalCount; count++) {
          if (type === "splitHor")
            myRect = this.addMaskDOM("rect", (mask_rect + count), 0, ((count * h / 2)), w, ((h / totalCount) + 1), val.getAttribute("stroke-width"))
          else
            myRect = this.addMaskDOM("rect", (mask_rect + count), ((count * w / 2)), 0, ((w / totalCount) + 1), h, val.getAttribute("stroke-width"))
          
          mask_tag.appendChild(myRect);
        }
        mySVG.setAttributeNS(null, "width", 0);
        mySVG.setAttributeNS(null, "height", 0);
        mySVG.appendChild(mask_tag);
        document.getElementById(elementId).appendChild(mySVG);
      }
      else if (type === "circle") {
        mask_name = "mymask_" + elementId + type;
        val.style.clipPath = "url(#" + mask_name + ")";
        val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";

        mask_tag.setAttributeNS(null, "id", mask_name);

        var myCir = document.createElementNS('http://www.w3.org/2000/svg', "circle");
        myCir.setAttributeNS(null, "id", mask_rect);
        myCir.setAttributeNS(null, "cx", (document.getElementById(elementId).offsetWidth) / 2);
        myCir.setAttributeNS(null, "cy", (document.getElementById(elementId).offsetHeight) / 2);
        myCir.setAttributeNS(null, "r", (document.getElementById(elementId).offsetWidth + document.getElementById(elementId).offsetHeight) / 2);
        myCir.setAttributeNS(null, "stroke-width", val.getAttribute("stroke-width"));
        myCir.setAttributeNS(null, "fill", "beige");
        myCir.setAttributeNS(null, "stroke", "beige");

        mask_tag.appendChild(myCir);

        mySVG.setAttributeNS(null, "width", 0);
        mySVG.setAttributeNS(null, "height", 0);

        mySVG.appendChild(mask_tag);
        document.getElementById(elementId).appendChild(mySVG);

      }
      else if (type === "circularReveal") {
        mask_name = "mymask_" + elementId + type;
        val.style.clipPath = "url(#" + mask_name + ")";
        val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";

        mask_tag.setAttributeNS(null, "id", mask_name);

        var myPath = document.createElementNS('http://www.w3.org/2000/svg', "path");
        myPath.setAttributeNS(null, "id", "arcPath" + elementId);
        myPath.setAttributeNS(null, "d", " ");

        mask_tag.appendChild(myPath);

        mySVG.setAttributeNS(null, "width", 0);
        mySVG.setAttributeNS(null, "height", 0);

        mySVG.appendChild(mask_tag);

        document.getElementById(elementId).appendChild(mySVG);
      }
      else {

        mask_name = "mymask_" + elementId + type;
        val.style.clipPath = "url(#" + mask_name + ")";
        val.style.webkitClipPath = "url(#" + mask_name + ")"; val.style.mozClipPath = "url(#" + mask_name + ")"; val.style.msClipPath = "url(#" + mask_name + ")"; val.style.oClipPath = "url(#" + mask_name + ")";

        mask_tag.setAttributeNS(null, "id", mask_name);

        var h = bounds.height > document.getElementById(elementId).offsetHeight ? bounds.height : document.getElementById(elementId).offsetHeight; //* Math.abs(Math.cos(rotation)) + bounds.width * Math.abs(Math.sin(rotation));
        var w = bounds.width > document.getElementById(elementId).offsetWidth ? bounds.width : document.getElementById(elementId).offsetWidth; //* Math.abs(Math.cos(rotation)) + bounds.height * Math.abs(Math.sin(rotation));
        if (type === "reveal" || type === "irish") {
          h = document.getElementById(elementId).offsetHeight;
          w = document.getElementById(elementId).offsetWidth;
        }

        myRect = this.addMaskDOM("rect", mask_rect, 0, 0, w, h);
        mask_tag.appendChild(myRect);

        mySVG.setAttributeNS(null, "width", 0);
        mySVG.setAttributeNS(null, "height", 0);
        mySVG.style.top = 0;

        if (rotation) {
          if (scaleX === scaleY)
            rotation *= -1;
          var rotVal = "rotate(" + rotation + ")"
          myRect.setAttribute("transform", rotVal);
        }

        mySVG.appendChild(mask_tag);
          document.getElementById(elementId).appendChild(mySVG);
        if (type !== "wipe" || (type === "wipe" && rotation !== 0)) {
          let newx = document.getElementById(elementId).getBoundingClientRect().x - document.getElementById(mask_rect).getBoundingClientRect().x;
          let newy = document.getElementById(elementId).getBoundingClientRect().y - document.getElementById(mask_rect).getBoundingClientRect().y;
          myRect.setAttribute("x", newx * scaleX);
          myRect.setAttribute("y", newy * scaleY);
        }

      }
    }
  }

  wipeExitHandler(innerblock, startTime, exitstart, effectType, rotation, scaleX, scaleY, opacity, isChild)
  {
    function onStartTween(blockId, type, rotation)
    {
      var maskFound = this.maskExist(blockId, "");
      if (!maskFound)
      {
        this.removeMask(blockId);
        this.addMask(blockId, "wipe", "", rotation, scaleX, scaleY, "", !innerblock.classList.contains("scene-item"));
      }
      var mask_rect = "#mask_" + blockId + "_rect";
      var idVal = document.getElementById(innerblock.id);
      var bboxVal = idVal.getBoundingClientRect();
      var offset = 2;
      var yval = document.getElementById("mask_" + innerblock.id + "_rect").getAttribute("y")
      var xval = document.getElementById("mask_" + innerblock.id + "_rect").getAttribute("x")
      TweenMax.set(mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
      TweenMax.set(innerblock, { opacity: opacity, transformOrigin: "50% 50%" });

      if (type === "wipeTop")
        this.tweenToHandler(mask_rect, startTime, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * scaleY) } }, exitstart);
      else if (type === "wipeDown")
        this.tweenToHandler(mask_rect, startTime, { attr: { y: parseFloat(yval) + ((bboxVal.height + offset) * -scaleY) } }, exitstart);
      else if (type === "wipeRight")
        this.tweenToHandler(mask_rect, startTime, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * -scaleX) } }, exitstart);
      else if (type === "wipeLeft")
        this.tweenToHandler(mask_rect, startTime, { attr: { x: parseFloat(xval) + ((bboxVal.width + offset) * scaleX) } }, exitstart);
      else if (this.props.browserName !== "Apple Safari")
      {
        if (type === "WipeBottom")
          this.tweenToHandler(mask_rect, startTime, { attr: { y: parseFloat(yval) + bboxVal.height + offset } }, exitstart);
        else if (type === "WipeTop")
          this.tweenToHandler(mask_rect, startTime, { attr: { y: parseFloat(yval) + (bboxVal.height + offset) * -1 } }, exitstart);
        else if (type === "WipeLeft")
          this.tweenToHandler(mask_rect, startTime, { attr: { x: parseFloat(xval) + (bboxVal.width + offset) * -1 } }, exitstart);
        else if (type === "WipeRight")
          this.tweenToHandler(mask_rect, startTime, { attr: { x: parseFloat(xval) + (bboxVal.width + offset) } }, exitstart);
      }
      else
      {
        if (type === "WipeBottom")
          this.tweenToHandler(mask_rect, startTime, { attr: { y: parseFloat(yval) + bboxVal.height + offset }, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + "wipe"] }, exitstart);
        else if (type === "WipeTop")
          this.tweenToHandler(mask_rect, startTime, { attr: { y: parseFloat(yval) + (bboxVal.height + offset) * -1 }, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + "wipe"] }, exitstart);
        else if (type === "WipeLeft")
          this.tweenToHandler(mask_rect, startTime, { attr: { x: parseFloat(xval) + (bboxVal.width + offset) * -1 }, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + "wipe"] }, exitstart);
        else if (type === "WipeRight")
          this.tweenToHandler(mask_rect, startTime, { attr: { x: parseFloat(xval) + (bboxVal.width + offset) }, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + "wipe"] }, exitstart);
      }
    }
    this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, effectType, rotation, opacity], opacity: opacity }, exitstart);
  }

  wipeEnterHandler(innerblock, startTime, effectType, rotation, scaleX, scaleY, enterTime, isChild)
  {
    this.removeMask(innerblock.id);
    if(innerblock.getElementsByClassName("text-container")[0])
      this.addMask(innerblock.id, "wipe", "", rotation, scaleX, scaleY, true);
    else
      this.addMask(innerblock.id, "wipe", "", rotation, scaleX, scaleY, false);
    var mask_rect = "#mask_" + innerblock.id + "_rect";
    var idVal = document.getElementById(innerblock.id);
    var bboxVal = idVal.getBoundingClientRect();

    TweenMax.set(mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
    //Inba - For wipe enter effect items - innerblock element is shown so changing its opacity to 0
    TweenMax.set(innerblock, { opacity: 0, transformOrigin: "50% 50%" });

    var yval = document.getElementById("mask_" + innerblock.id + "_rect").getAttribute("y")
    var xval = document.getElementById("mask_" + innerblock.id + "_rect").getAttribute("x")

    if (effectType === "wipeTop")
      this.tweenfromHandler(mask_rect, startTime, { attr: { y: parseFloat(yval) + ((bboxVal.height) * -scaleY) } }, enterTime);
    else if (effectType === "wipeDown")
      this.tweenfromHandler(mask_rect, startTime, { attr: { y: parseFloat(yval) + ((bboxVal.height) * scaleY) } }, enterTime);
    else if (effectType === "wipeRight")
      this.tweenfromHandler(mask_rect, startTime, { attr: { x: parseFloat(xval) + ((bboxVal.width) * scaleX) } }, enterTime);
    else if (effectType === "wipeLeft")
      this.tweenfromHandler(mask_rect, startTime, { attr: { x: parseFloat(xval) + ((bboxVal.width) * -scaleX) } }, enterTime)

      this.tweenToHandler(innerblock, 0.1, {"clip-path" : ""}, enterTime + startTime);
    }
  splitFromCenterEnterHandler(innerblock, startTime, effectType, enterTime, isChild)
  {
    this.removeMask(innerblock.id, "reveal");
    this.addMask(innerblock.id, "reveal");
    var mask_rect = "#mask_" + innerblock.id + "_rect";

    TweenMax.set(mask_rect, { attr: { x: 0, y: 0 }, opacity: 1, transformOrigin: "50% 50%" });
    TweenMax.set(innerblock, { opacity: 1, transformOrigin: "50% 50%" });

    if (effectType === "verticalSplit")
      this.tweenFromToHandler(mask_rect, startTime, { scaleX: 0, transformOrigin: "50% 50%" }, { scaleX: 1, transformOrigin: "50% 50%", attr: { y: 0 } }, enterTime);

    else if (effectType === "horizontalSplit")
      this.tweenFromToHandler(mask_rect, startTime, { scaleY: 0, transformOrigin: "50% 50%" }, { scaleY: 1, transformOrigin: "50% 50%", attr: { y: 0 } }, enterTime);
  }

  irishExitHandler(innerblock, startTime, exitstart, effectType, isChild)
  {
    function onStartTween(blockId, type)
    {
      if (!type)
        type = "";
      var maskFound = this.maskExist(blockId, type);
      if (!maskFound)
      {
        this.removeMask(blockId);
        this.addMask(blockId, type);
      }

      var mask_rect = "#mask_" + blockId + "_rect";
      TweenMax.set(mask_rect, { scale: 1, transformOrigin: "50% 50%" });
      TweenMax.set(innerblock, { scale: 1, transformOrigin: "50% 50%" });
      if ((effectType !== "SlideIrisSquare" && effectType !== "SlideIrisCircle") || (this.props.browserName !== "Apple Safari"))
        this.tweenToHandler(mask_rect, startTime, { scale: 0, transformOrigin: "50% 50%" }, exitstart);
      else if (this.props.browserName === "Apple Safari" && (effectType === "SlideIrisSquare" || effectType === "SlideIrisCircle"))
        this.tweenToHandler(mask_rect, startTime, { scale: 0, transformOrigin: "50% 50%", onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, exitstart);
    }

    if (effectType === "irishSquare" || effectType === "SlideIrisSquare")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "irish"], opacity: 1 }, exitstart);
    else if (effectType === "irishCircle" || effectType === "SlideIrisCircle")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "circle"], opacity: 1 }, exitstart);
  }

  circularHideAntiClockwiseBottom(innerblock, startTime, t1, exitstart)
  {
    function onStartTween(blockId, type)
    {
      if (!type)
        type = "";
      var maskFound = this.maskExist(blockId, type);
      if (!maskFound)
      {
        this.removeMask(blockId);
        this.addMask(blockId, type);
      }

      var mask_rect = "#mask_" + blockId + "_rect";
      TweenMax.set(mask_rect, { rotation: "-270", transformOrigin: "50% 50%" });
      this.tweenFromToHandler(mask_rect, startTime, { drawSVG: "0% 100%" }, { drawSVG: "100% 100%" }, exitstart);
    }

    this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "circularReveal"], opacity: 1 }, exitstart);
  }

  moveEnterHandler(innerblock, xval, yval, rotation, startTime, enterstart, effectType, scaleX, scaleY, isChild)
  {
    this.removeMask(innerblock.id);
    this.addMask(innerblock.id, "wipe", "", rotation, scaleX, scaleY);
    var mask_rect = "#mask_" + innerblock.id + "_rect";
    var idVal = document.getElementById(innerblock.id);
    var bboxVal = idVal.getBoundingClientRect();
    var yvalue = document.getElementById("mask_" + innerblock.id + "_rect").getAttribute("y")
    var xvalue = document.getElementById("mask_" + innerblock.id + "_rect").getAttribute("x")
    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    if (effectType === "moveFromTop")
    {
        this.tweenFromToHandler(innerblock, startTime, { y: (yval - innerblock.offsetHeight - groupYoffset) }, { y: yval - groupYoffset }, enterstart);
      this.tweenfromHandler(mask_rect, startTime, { attr: { y: parseFloat(yvalue) + (innerblock.offsetHeight * scaleY) } }, enterstart);
    }
    else if (effectType === "moveFromDown")
    {
        this.tweenFromToHandler(innerblock, startTime, { y: (yval + innerblock.offsetHeight) - groupYoffset }, { y: yval - groupYoffset }, enterstart);
      this.tweenfromHandler(mask_rect, startTime, { attr: { y: parseFloat(yvalue) + (innerblock.offsetHeight * -scaleY) } }, enterstart);
    }
    else if (effectType === "moveFromLeft")
    {
        this.tweenFromToHandler(innerblock, startTime, { x: (xval - innerblock.offsetWidth) - groupXoffset }, {x: xval - groupXoffset}, enterstart);
      this.tweenfromHandler(mask_rect, startTime, { attr: { x: parseFloat(xvalue) + (innerblock.offsetWidth * scaleX) } }, enterstart);

    }
    else if (effectType === "moveFromRight")
    {
        this.tweenFromToHandler(innerblock, startTime, { x: (xval + innerblock.offsetWidth) - groupXoffset }, { x: xval - groupXoffset}, enterstart);
      this.tweenfromHandler(mask_rect, startTime, { attr: { x: parseFloat(xvalue) + (innerblock.offsetWidth * -scaleX) } }, enterstart);

    }
    this.tweenToHandler(innerblock, 0.1, {"clip-path" : ""}, enterstart + startTime);
  }


  photoEnterHandler(innerblock, xval, yval, startTime, enterstart, isChild)
  {
    this.removeMask(innerblock.id);
    this.tweenFromToHandler(innerblock, startTime, { opacity: 0 }, { opacity: 1 }, enterstart)
  }

  pixelEnterHandler(innerblock, xval, yval, startTime, enterstart, isChild)
  {
    this.removeMask(innerblock.id);
    this.addMask(innerblock.id, "pixelsquare");
    var mask_rect = "#mask_" + innerblock.id + "_rect";
    var totalCount = 20;

    var maskGroup = [];
    for (var count = 0; count < totalCount; count++)
    {
      for (var cnt = 0; cnt < totalCount; cnt++)
      {
        maskGroup.push(mask_rect + count + cnt);
      }
    }
    maskGroup = shuffle(maskGroup);

    function shuffle(array)
    {
      var m = array.length, t, i;
      while (m)
      {
        i = Math.floor(Math.random() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
      }
      return array;
    }
    this.tweenStaggerFromToHandler(maskGroup, startTime, { transformOrigin: "50% 50%", display: "none" }, { transformOrigin: "50% 50%", display: "block" }, startTime / Math.pow(totalCount, 2), enterstart);
    this.tweenToHandler(innerblock, 0.01, {"clip-path": ""}, startTime+enterstart);
  }

  brightSquareEnterHandler(innerblock, xval, yval, startTime, enterstart, isChild)
  {
    this.removeMask(innerblock.id);
    this.addMask(innerblock.id, "square");
    var mask_rect = "#mask_" + innerblock.id + "_rect";

    var totalCount = 6;

    for (var count = 0; count < totalCount; count++)
    {
      for (var cnt = 0; cnt < totalCount; cnt++)
      {
        this.tweenFromToHandler(mask_rect + count + cnt, startTime, { transformOrigin: "50% 50%", scale: 0 }, { transformOrigin: "50% 50%", scale: 1 }, enterstart);
      }
    }
    this.tweenToHandler(innerblock, 0.01, {"clip-path" : ""}, enterstart + startTime);
  }

  stripeExitHandler(innerblock, xval, yval, startTime, enterstart, effectType, scaleX, scaleY, opacity, isChild)
  {
    if (scaleY === -1 || scaleX === -1)
    {
      if (effectType === "stripeTopLeft" && scaleY === -1 && scaleX === 1) effectType = "stripe_Bottomleft";
      else if (effectType === "stripeTopLeft" && scaleX === -1 && scaleY === 1) effectType = "stripe_Topright";
      else if (effectType === "stripeTopLeft" && scaleX === -1 && scaleY === -1) effectType = "stripe_Bottomright";
      else if (effectType === "stripe_Topright" && scaleY === -1 && scaleX === 1) effectType = "stripe_Bottomright";
      else if (effectType === "stripe_Topright" && scaleX === -1 && scaleY === 1) effectType = "stripeTopLeft";
      else if (effectType === "stripe_Topright" && scaleX === -1 && scaleY === -1) effectType = "stripe_Bottomleft";
      else if (effectType === "stripe_Bottomleft" && scaleY === -1 && scaleX === 1) effectType = "stripeTopLeft";
      else if (effectType === "stripe_Bottomleft" && scaleX === -1 && scaleY === 1) effectType = "stripe_Bottomright";
      else if (effectType === "stripe_Bottomleft" && scaleX === -1 && scaleY === -1) effectType = "stripe_Topright";
      else if (effectType === "stripe_Bottomright" && scaleY === -1 && scaleX === 1) effectType = "stripe_Topright";
      else if (effectType === "stripe_Bottomright" && scaleX === -1 && scaleY === 1) effectType = "stripe_Bottomleft";
      else if (effectType === "stripe_Bottomright" && scaleX === -1 && scaleY === -1) effectType = "stripeTopLeft";
      else if (effectType === "stripeLeftTop" && scaleY === -1 && scaleX === 1) effectType = "stripeLeftBottom";
      else if (effectType === "stripeLeftTop" && scaleX === -1 && scaleY === 1) effectType = "stripeRightTop";
      else if (effectType === "stripeLeftTop" && scaleX === -1 && scaleY === -1) effectType = "stripeRightBottom";
      else if (effectType === "stripeRightTop" && scaleY === -1 && scaleX === 1) effectType = "stripeRightBottom";
      else if (effectType === "stripeRightTop" && scaleX === -1 && scaleY === 1) effectType = "stripeLeftTop";
      else if (effectType === "stripeRightTop" && scaleX === -1 && scaleY === -1) effectType = "stripeLeftBottom";
      else if (effectType === "stripeLeftBottom" && scaleY === -1 && scaleX === 1) effectType = "stripeLeftTop";
      else if (effectType === "stripeLeftBottom" && scaleX === -1 && scaleY === 1) effectType = "stripeRightBottom";
      else if (effectType === "stripeLeftBottom" && scaleX === -1 && scaleY === -1) effectType = "stripeRightTop";
      else if (effectType === "stripeRightBottom" && scaleY === -1 && scaleX === 1) effectType = "stripeRightTop";
      else if (effectType === "stripeRightBottom" && scaleX === -1 && scaleY === 1) effectType = "stripeLeftBottom";
      else if (effectType === "stripeRightBottom" && scaleX === -1 && scaleY === -1) effectType = "stripeLeftTop";
    }
    function onStartTween(blockId, type, effectType)
    {
      if (!type)
        type = "";
      var maskFound = this.maskExist(blockId, type);
      if (!maskFound)
      {
        this.removeMask(blockId);
        this.addMask(blockId, type);
      }
      var mask_rect = "#mask_" + blockId + "_rect";
      var totalCount = 10;
      var num = 0, count = 0;
      TweenMax.set(mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
      TweenMax.set(innerblock, { opacity: opacity, transformOrigin: "50% 50%" });

      if (effectType === "stripe_Topright" || effectType === "stripeTopLeft" || effectType === "stripeLeftTop" || effectType === "stripeLeftBottom" ||
        effectType === "stripeRightBottom" || effectType === "SlideStripeRight" || effectType === "SlideStripeLeft" || effectType === "SlideStripeBottom" || effectType === "SlideStripeTop")
      {
        for (count = 0; count < totalCount; count++)
        {

          if (effectType === "stripeTopLeft")
            this.tweenToHandler(mask_rect + count, startTime / totalCount, { scaleX: 0 }, enterstart + ((count * startTime) / totalCount));
          else if (effectType === "stripe_Topright")
            this.tweenToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "100%", scaleX: 0 }, enterstart + ((count * startTime) / totalCount));
          else if (effectType === "stripeLeftBottom")
            this.tweenToHandler(mask_rect + count, startTime / totalCount, { scaleY: 0 }, enterstart + ((count * startTime) / totalCount));
          else if (effectType === "stripeLeftTop")
            this.tweenToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "bottom", scaleY: 0 }, enterstart + ((count * startTime) / totalCount));
          else if (effectType === "stripeRightBottom")
            this.tweenToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "bottom", scaleY: 0 }, enterstart + ((num * startTime) / totalCount));
          else if (this.props.browserName !== "Apple Safari")
          {
            if (effectType === "SlideStripeRight")
              this.tweenToHandler(mask_rect + count, startTime / totalCount, { scaleX: 0 }, enterstart + ((count * startTime) / totalCount));
            else if (effectType === "SlideStripeLeft")
              this.tweenToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "100%", scaleX: 0 }, enterstart + ((count * startTime) / totalCount));
            else if (effectType === "SlideStripeBottom")
              this.tweenToHandler(mask_rect + count, startTime / totalCount, { scaleY: 0 }, enterstart + ((count * startTime) / totalCount));
            else if (effectType === "SlideStripeTop")
              this.tweenToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "bottom", scaleY: 0 }, enterstart + ((count * startTime) / totalCount));
          }
          else
          {
            if (effectType === "SlideStripeRight")
              this.tweenToHandler(mask_rect + count, startTime / totalCount, { scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, enterstart + ((count * startTime) / totalCount));
            else if (effectType === "SlideStripeLeft")
              this.tweenToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "100%", scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, enterstart + ((count * startTime) / totalCount));
            else if (effectType === "SlideStripeBottom")
              this.tweenToHandler(mask_rect + count, startTime / totalCount, { scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, enterstart + ((count * startTime) / totalCount));
            else if (effectType === "SlideStripeTop")
              this.tweenToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "bottom", scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, enterstart + ((count * startTime) / totalCount));
          }
          num++;
        }
      }
      else if (effectType === "stripe_Bottomleft" || effectType === "stripe_Bottomright" || effectType === "stripeRightTop")
      {
        for (count = totalCount; count >= 0; count--)
        {
          if (effectType === "stripe_Bottomright")
            this.tweenToHandler(mask_rect + count, startTime / totalCount, { scaleX: 0 }, enterstart + ((num * startTime) / totalCount));
          else if (effectType === "stripe_Bottomleft")
            this.tweenToHandler(mask_rect + count, startTime / totalCount, { transformOrigin: "100%", scaleX: 0 }, enterstart + ((num * startTime) / totalCount));
          else if (effectType === "stripeRightTop")
            this.tweenToHandler(mask_rect + count, startTime / totalCount, { scaleY: 0 }, enterstart + ((num * startTime) / totalCount));
          num++;
        }
      }
    }

    if (effectType === "stripe_Topright" || effectType === "SlideStripeRight")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiHeight", effectType], opacity: 1 }, enterstart);
    else if (effectType === "stripeTopLeft" || effectType === "SlideStripeLeft")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiHeight", effectType], opacity: 1 }, enterstart);
    else if (effectType === "stripe_Bottomleft")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiHeight", effectType], opacity: 1 }, enterstart);
    else if (effectType === "stripe_Bottomright")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiHeight", effectType], opacity: 1 }, enterstart);
    else if (effectType === "stripeLeftBottom" || effectType === "SlideStripeBottom")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiWidth", effectType], opacity: 1 }, enterstart);
    else if (effectType === "stripeRightTop")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiWidth", effectType], opacity: 1 }, enterstart);
    else if (effectType === "stripeLeftTop" || effectType === "SlideStripeTop")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiWidth", effectType], opacity: 1 }, enterstart);
    else if (effectType === "stripeRightBottom")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiWidth", effectType], opacity: 1 }, enterstart);
  }

  blindsEnterHandler(innerblock, xval, yval, startTime, enterstart, effectName, scaleX, scaleY, isChild)
  {
    this.removeMask(innerblock.id);
    if (scaleY === -1 || scaleX === -1)
    {
      if (effectName === "blindsTop" && scaleY === -1)
        effectName = "blindsBottom";
      else if (effectName === "blindsBottom" && scaleY === -1)
        effectName = "blindsTop";
      else if (effectName === "blindsRight" && scaleX === -1)
        effectName = "blindsLeft";
      else if (effectName === "blindsLeft" && scaleX === -1)
        effectName = "blindsRight";
    }
    if (effectName === "blindsLeft" || effectName === "blindsRight")
      this.addMask(innerblock.id, "multiWidth");
    else if (effectName === "blindsTop" || effectName === "blindsBottom")
      this.addMask(innerblock.id, "multiHeight");
    var mask_rect = "#mask_" + innerblock.id + "_rect";

    var totalCount = 10;
    for (var count = 0; count < totalCount; count++)
    {
      if (effectName === "blindsLeft")
        this.tweenFromToHandler(mask_rect + count, startTime, { scaleX: 0 }, { scaleX: 1 }, enterstart);
      else if (effectName === "blindsRight")
        this.tweenFromToHandler(mask_rect + count, startTime, { transformOrigin: "100%", scaleX: 0 }, { transformOrigin: "100%", scaleX: 1 }, enterstart);
      else if (effectName === "blindsTop")
        this.tweenFromToHandler(mask_rect + count, startTime, { scaleY: 0 }, { scaleY: 1 }, enterstart);
      else if (effectName === "blindsBottom")
        this.tweenFromToHandler(mask_rect + count, startTime, { transformOrigin: "bottom", scaleY: 0 }, { transformOrigin: "bottom", scaleY: 1 }, enterstart);
    }
    this.tweenToHandler(innerblock, 0.1, {"clip-path" : ""}, startTime + enterstart);
  }

  blindsExitHandler(innerblock, xval, yval, endTime, exitstart, effectType, scaleX, scaleY, opacity, isChild)
  {
    if (scaleY === -1 || scaleX === -1)
    {
      if (effectType === "blindsTop" && scaleY === -1)
        effectType = "blindsBottom";
      else if (effectType === "blindsBottom" && scaleY === -1)
        effectType = "blindsTop";
      else if (effectType === "blindsRight" && scaleX === -1)
        effectType = "blindsLeft";
      else if (effectType === "blindsLeft" && scaleX === -1)
        effectType = "blindsRight";
    }
    function onStartTween(blockId, type)
    {
      if (!type)
        type = "";
      var maskFound = this.maskExist(blockId, type);
      if (!maskFound)
      {
        this.removeMask(blockId);
        this.addMask(blockId, type);
      }
      var mask_rect = "#mask_" + blockId + "_rect";
      TweenMax.set(mask_rect, { opacity: 1, transformOrigin: "50% 50%" });
      TweenMax.set(innerblock, { opacity: opacity, transformOrigin: "50% 50%" });

      var totalCount = 10;
      for (var count = 0; count < totalCount; count++)
      {
        if (effectType === "blindsLeft")
          this.tweenToHandler(mask_rect + count, endTime, { scaleX: 0 }, exitstart);
        else if (effectType === "blindsRight")
          this.tweenToHandler(mask_rect + count, endTime, { transformOrigin: "100%", scaleX: 0 }, exitstart);
        else if (effectType === "blindsTop")
          this.tweenToHandler(mask_rect + count, endTime, { scaleY: 0 }, exitstart);
        else if (effectType === "blindsBottom")
          this.tweenToHandler(mask_rect + count, endTime, { transformOrigin: "bottom", scaleY: 0 }, exitstart);
        else if (this.props.browserName !== "Apple Safari")
        {
          if (effectType === "SlideBlindsVerLeft")
            this.tweenToHandler(mask_rect + count, endTime, { scaleX: 0 }, exitstart);
          else if (effectType === "SlideBlindsVerRight")
            this.tweenToHandler(mask_rect + count, endTime, { transformOrigin: "100%", scaleX: 0 }, exitstart);
          else if (effectType === "SlideBlindsHorUp")
            this.tweenToHandler(mask_rect + count, endTime, { scaleY: 0 }, exitstart);
          else if (effectType === "SlideBlindsHorDown")
            this.tweenToHandler(mask_rect + count, endTime, { transformOrigin: "bottom", scaleY: 0 }, exitstart);
        }
        else
        {
          if (effectType === "SlideBlindsVerLeft")
            this.tweenToHandler(mask_rect + count, endTime, { scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, exitstart);
          else if (effectType === "SlideBlindsVerRight")
            this.tweenToHandler(mask_rect + count, endTime, { transformOrigin: "100%", scaleX: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, exitstart);
          else if (effectType === "SlideBlindsHorUp")
            this.tweenToHandler(mask_rect + count, endTime, { scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, exitstart);
          else if (effectType === "SlideBlindsHorDown")
            this.tweenToHandler(mask_rect + count, endTime, { transformOrigin: "bottom", scaleY: 0, onUpdate: this.redrawClipPath, onUpdateParams: [innerblock, "#mymask_" + blockId + type] }, exitstart);
        }
      }
    }
    if (effectType === "blindsLeft" || effectType === "SlideBlindsVerLeft")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiWidth"], opacity: 1 }, exitstart);
    else if (effectType === "blindsRight" || effectType === "SlideBlindsVerRight")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiWidth"], opacity: 1 }, exitstart);
    else if (effectType === "blindsTop" || effectType === "SlideBlindsHorUp")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiHeight"], opacity: 1 }, exitstart);
    else if (effectType === "blindsBottom" || effectType === "SlideBlindsHorDown")
      this.tweenfromHandler(innerblock.id, 0.1, { onStart: onStartTween.bind(this), onStartParams: [innerblock.id, "multiHeight"], opacity: 1 }, exitstart);
  }

  irishEnterHandler(innerblock, startTime, effectType, enterTime, isChild)
  {
    this.removeMask(innerblock.id);
    if (effectType === "irishSquare")
      this.addMask(innerblock.id, "irish");
    else if (effectType === "irishCircle")
      this.addMask(innerblock.id, "circle");

    var mask_rect = "#mask_" + innerblock.id + "_rect";
    TweenMax.set(mask_rect, { attr: { x: 0, y: 0 }, opacity: 1, transformOrigin: "50% 50%" });
    TweenMax.set(innerblock, { opacity: 1, transformOrigin: "50% 50%" });
    this.tweenFromToHandler(mask_rect, startTime, { scale: 0, transformOrigin: "50% 50%" }, { scale: 1, transformOrigin: "50% 50%" }, enterTime);
  }

  EnterFromRightBottom(innerblock, startTime, heightVal, widthVal, xval, yval, enterTime, isChild)
  {
    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { x: this.projectWidth * this.props.zoomFactor, y: this.projectHeight * this.props.zoomFactor });
    this.tweenToHandler(innerblock, startTime, { x: xval - groupXoffset, y: yval - groupYoffset}, enterTime);
  }

  EnterFromLeftTop(innerblock, startTime, heightVal, widthVal, xval, yval, enterTime, isChild)
  {
    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { x: widthVal * (-1), y: heightVal * (-1) });
    this.tweenToHandler(innerblock, startTime, { x: xval - groupXoffset, y: yval - groupYoffset}, enterTime);
  }

  EnterFromLeftBottom(innerblock, startTime, heightVal, widthVal, xval, yval, enterTime, isChild)
  {
    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { x: widthVal * (-1), y: this.projectHeight * this.props.zoomFactor });
    this.tweenToHandler(innerblock, startTime, { x: xval - groupXoffset, y: yval - groupYoffset }, enterTime);
  }

  EnterFromBottom(innerblock, startTime, heightVal, widthVal, xval, yval, enterTime, isChild)
  {
    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { y: this.projectHeight * this.props.zoomFactor });
    this.tweenToHandler(innerblock, startTime, { x: xval - groupXoffset, y: yval - groupYoffset }, enterTime);
  }

  EnterFromTop(innerblock, startTime, heightVal, widthVal, xval, yval, enterTime, isChild)
  {
    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { y: heightVal * (-1) });
    this.tweenToHandler(innerblock, startTime, { x: xval - groupXoffset, y: yval - groupYoffset }, enterTime);
  }

  EnterFromLeft(innerblock, startTime, heightVal, widthVal, xval, yval, enterTime, isChild)
  {
    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { x: widthVal * (-1) });
    this.tweenToHandler(innerblock, startTime, { x: xval - groupXoffset, y: yval - groupYoffset }, enterTime);
  }

  EnterFromRight(innerblock, startTime, heightVal, widthVal, xval, yval, enterTime, isChild)
  {
    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { x: this.projectWidth * this.props.zoomFactor });
    this.tweenToHandler(innerblock, startTime, { x: xval - groupXoffset, y: yval - groupYoffset }, enterTime);
  }

  EnterFromRightTop(innerblock, startTime, heightVal, widthVal, xval, yval, enterTime, isChild)
  {

    var groupXoffset = 0, groupYoffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { x: this.projectWidth * this.props.zoomFactor, y: heightVal * (-1) });
    this.tweenToHandler(innerblock, startTime, { x: xval - groupXoffset, y: yval - groupXoffset }, enterTime);
  }

  rotationEnterHandler(innerblock, startTime, rotation, scaleX, scaleY, time, isChild)
  {
    this.removeMask(innerblock.id);
    this.tweenFromToHandler(innerblock, startTime, { scale: 0, transformOrigin: "50% 50%" }, { scaleX: scaleX, scaleY: scaleY, rotation: rotation + 360, transformOrigin: "50% 50%"}, time);
    this.tweenToHandler(innerblock, 0.001, {rotation: rotation}, time+startTime);
  }

  blurEnterHandler(innerblock, startTime)
  {
    this.removeMask(innerblock.id);
    this.addFilter(innerblock.id);
    var filterName = "#myfilter_" + innerblock.id;

    var blurNode = (filterName);
    return TweenMax.to(blurNode, startTime, { attr: { stdDeviation: 0 } }, "blur");
  }

  popupHandler(innerblock, startTime, scaleX, scaleY, enterTime, isChild)
  {
    this.removeMask(innerblock.id);
    TweenMax.set(innerblock, { scaleX: 0, scaleY: 0, transformOrigin: "50% 50%" });
    this.tweenToHandler(innerblock, startTime, { scaleX: scaleX, scaleY: scaleY, transformOrigin: "50% 50%", immediateRender: false, ease: Back.easeOut }, enterTime);
  }


  popupTransformHandler(innerblock, startTime, scaleX, scaleY, enterTime, type, rotation, xval, yval, isChild)
  {
    var groupXoffset = 0, groupYoffset = 0, rotateHeightOffset = 0, rotateWidthOffset = 0;

    if(isChild) {
      groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
      groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
    }

    if(rotation) {
      rotateHeightOffset = (innerblock.getBoundingClientRect().height - innerblock.clientHeight)/2
      rotateWidthOffset = (innerblock.getBoundingClientRect().width - innerblock.clientWidth)/2;
    }
    var updateWrapper = () => {
      if(!document.getElementById(innerblock.id + "_tempWrapper")){
        var parent = innerblock.parentNode;
        var wrapper = document.createElement("div");
        parent.replaceChild(wrapper, innerblock);
        wrapper.appendChild(innerblock);
        innerblock.parentNode.style.width = innerblock.getBoundingClientRect().width + "px";
        innerblock.parentNode.style.height = innerblock.getBoundingClientRect().height + "px";
        innerblock.parentNode.style.display = "block";
        innerblock.parentNode.style.position = "absolute";
        innerblock.parentNode.setAttribute("id", innerblock.id + "_tempWrapper");
        var transformOriginVal = "0% 0%"
        if (type === "popupFromLeft")
          transformOriginVal = "0% 50%"
        if (type === "popupFromRight")
          transformOriginVal = "100% 50%"
        if (type === "popupFromTop")
          transformOriginVal = "50% 0%"
        if (type === "popupFromBottom")
          transformOriginVal = "50% 100%"
        if (type === "popupFromBottomLeft")
          transformOriginVal = "0% 100%"
        if (type === "popupFromBottomRight")
          transformOriginVal = "100% 100%"
        if (type === "popupFromTopLeft")
          transformOriginVal = "0% 0%"
        if (type === "popupFromTopRight")
          transformOriginVal = "100% 0%"
        if (type === "popupFromCenter")
          transformOriginVal = "50% 50%"


        this.removeMask(innerblock.id);
        this.t1.to( innerblock.parentNode, startTime, { scaleX: 1, scaleY: 1, immediateRender: false, ease: Back.easeOut, }, enterTime );
        innerblock.style.left = -xval + rotateWidthOffset + groupXoffset + "px";
        innerblock.style.top = -yval + rotateHeightOffset + groupYoffset + "px";
        TweenMax.set(innerblock.parentNode, { x: xval - groupXoffset - rotateWidthOffset, y: yval - groupYoffset - rotateHeightOffset, transformOrigin: transformOriginVal, scaleX: 0, scaleY: 0 });
      }
    }
   
      function delWrapper() {
        // var parentNode = innerblock.parentNode.parentNode;
        // parentNode.insertBefore(innerblock, innerblock.parentNode);
        if(document.getElementById(innerblock.id + "_tempWrapper"))
          {
          document.getElementById(innerblock.id + "_tempWrapper").replaceWith(...document.getElementById(innerblock.id + "_tempWrapper").childNodes)
          }
        // parentNode.appendChild(innerblock);
      }
      this.t1.addCallback(delWrapper, startTime+enterTime);

      // To revert the position of the innerblock.

      function revertPosition() {
        innerblock.style.left = "0px";
        innerblock.style.top = "0px";
      }
      
      this.t1.addCallback(revertPosition, startTime+enterTime);
      this.t1.addCallback(updateWrapper,enterTime-0.01);
  }

  rotateZoominPopup(innerblock, tween_duration, enterstart, effectType, rotation, scaleX, scaleY, isChild)
  {
    this.removeMask(innerblock.id);
    this.tweenFromToHandler(innerblock, tween_duration, { scale: 0, transformOrigin: "50% 50%", immediateRender: false }, { scaleX: scaleX, scaleY: scaleY, transformOrigin: "50% 50%", ease: Back.easeOut }, enterstart);

    if (effectType === "rotateZoomInPopupCw")
      this.tweenFromToHandler(innerblock, tween_duration - tween_duration / 2, { rotation: "-=180", transformOrigin: "50% 50%" }, { rotation: rotation, transformOrigin: "50% 50%" }, enterstart);

    else if (effectType === "rotateZoomInPopupCcw")
      this.tweenFromToHandler(innerblock, tween_duration - tween_duration / 2, { rotation: "+=180", transformOrigin: "50% 50%" }, { rotation: rotation, transformOrigin: "50% 50%" }, enterstart);
  }

  rotateZoomin(innerblock, tween_duration, enterstart, effectName, rotation, scaleX, scaleY, isChild)
  {
    this.removeMask(innerblock.id);
    if (effectName === "rotateZoomInCw")
      this.tweenFromToHandler(innerblock, tween_duration, { scale: 0, rotation: "-=180", transformOrigin: "50% 50%", immediateRender: false }, { scaleX: scaleX, scaleY: scaleY, rotation: rotation, transformOrigin: "50% 50%" }, enterstart);
    else if (effectName === "rotateZoomInCcw")
      this.tweenFromToHandler(innerblock, tween_duration, { rotation: "+=180", scale: 0, transformOrigin: "50% 50%" }, { rotation: rotation, scaleX: scaleX, scaleY: scaleY, transformOrigin: "50% 50%" }, enterstart);
  }

  bigToNormal(innerblock, tween_duration, enterstart, scaleX, scaleY, opacity, width, height, rotation, isChild)
  {
    this.removeMask(innerblock.id);
    this.tweenFromToHandler(innerblock, tween_duration, { opacity: 0, scaleX: scaleX * 1.5, scaleY: scaleY * 1.5, rotation: rotation}, { opacity: opacity, scaleX: scaleX, scaleY: scaleY }, enterstart);
  }

  fadeinWithZoom(innerblock, tween_duration, scaleX, scaleY, opacity, rotation, xVal, yVal, enterstart, isChild)
  {
    this.removeMask(innerblock.id);
    this.tweenFromToHandler(innerblock, tween_duration, { alpha: 0 }, { alpha: opacity, force3D: true }, enterstart);
    var popupHandler = (innerblock, startTime, enterTime, rotation, xval, yval, isChild) =>
    {

      var groupXoffset = 0, groupYoffset = 0, rotateHeightOffset = 0, rotateWidthOffset = 0;

      if(isChild) {
        groupXoffset = innerblock.parentNode.getBoundingClientRect().x - innerblock.parentNode.parentNode.getBoundingClientRect().x;
        groupYoffset = innerblock.parentNode.getBoundingClientRect().y - innerblock.parentNode.parentNode.getBoundingClientRect().y;
      }

      if(rotation) {
        rotateHeightOffset = (innerblock.getBoundingClientRect().height - innerblock.clientHeight)/2
        rotateWidthOffset = (innerblock.getBoundingClientRect().width - innerblock.clientWidth)/2;
      }

      var updateWrapper = () => {
        if(!document.getElementById(innerblock.id + "_tempWrapper")){
          var parent = innerblock.parentNode;
          var wrapper = document.createElement("div");
          parent.replaceChild(wrapper, innerblock);
          wrapper.appendChild(innerblock);
          innerblock.parentNode.style.width = innerblock.getBoundingClientRect().width + "px";
          innerblock.parentNode.style.height = innerblock.getBoundingClientRect().height + "px";
          innerblock.parentNode.style.display = "block";
          innerblock.parentNode.style.position = "absolute";
          innerblock.parentNode.setAttribute("id", innerblock.id + "_tempWrapper");
          var transformOriginVal = "50% 50%";
  
          this.removeMask(innerblock.id);
          this.tweenToHandler( innerblock.parentNode, startTime, { scaleX: 1, scaleY: 1, immediateRender: false, ease: Back.easeOut, }, enterTime );
          innerblock.style.left = -xval + rotateWidthOffset + groupXoffset + "px";
          innerblock.style.top = -yval + rotateHeightOffset + groupYoffset + "px";
          TweenMax.set(innerblock.parentNode, { x: xval - groupXoffset - rotateWidthOffset, y: yval - groupYoffset - rotateHeightOffset, transformOrigin:transformOriginVal, scaleX: 0, scaleY: 0 });
        }
      }
      // Inba - Added if condition to add callbacks for one scene only, muitlple scenes reverse not 
      // not showing any effects.
      if(this.props.projectData.get('scenes').size === 1){
        function delWrapper() {
          // var parentNode = innerblock.parentNode.parentNode;
          // parentNode.insertBefore(innerblock, innerblock.parentNode);
          if(document.getElementById(innerblock.id + "_tempWrapper"))
            {
            document.getElementById(innerblock.id + "_tempWrapper").replaceWith(...document.getElementById(innerblock.id + "_tempWrapper").childNodes)
            }
          // parentNode.appendChild(innerblock);
        }
        this.t1.addCallback(delWrapper, startTime+enterTime);

        // // To revert the position of the innerblock.

        function revertPosition() {
          innerblock.style.left = "0px";
          innerblock.style.top = "0px";
        }
        
        this.t1.addCallback(revertPosition, startTime+enterTime);
      }
        this.t1.addCallback(updateWrapper,enterTime+0.001);
    }
    popupHandler(innerblock, tween_duration - tween_duration / 2, enterstart, rotation, xVal, yVal, isChild);
  }

  drawSVGHandler(innerblock, startTime)
  {
    this.removeMask(innerblock.id);
    TweenMax.set(innerblock.querySelectorAll("path")[0], { drawSVG: "0%" });
    return TweenMax.to(innerblock.querySelectorAll("path")[0], startTime, { drawSVG: "100%" })
  }

}



// WEBPACK FOOTER //
// ./src/components/PlayerComponent.js